webpackJsonp([4],{

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(275);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _Header = __webpack_require__(280);

var _Header2 = _interopRequireDefault(_Header);

var _Footer = __webpack_require__(283);

var _Footer2 = _interopRequireDefault(_Footer);

var _SnappIntro = __webpack_require__(491);

var _SnappIntro2 = _interopRequireDefault(_SnappIntro);

var _SnappFeatures = __webpack_require__(490);

var _SnappFeatures2 = _interopRequireDefault(_SnappFeatures);

var _DownloadSection = __webpack_require__(337);

var _DownloadSection2 = _interopRequireDefault(_DownloadSection);

var _reactDocumentMeta = __webpack_require__(288);

var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);

var _SnappFeatures3 = __webpack_require__(514);

var _SnappFeatures4 = _interopRequireDefault(_SnappFeatures3);

var _SnappServicesSection = __webpack_require__(493);

var _SnappServicesSection2 = _interopRequireDefault(_SnappServicesSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Meta = __webpack_require__(297).MainPage;

var MainPage = (0, _createReactClass2.default)({
    render: function render() {
        return _react2.default.createElement(
            'div',
            { className: 'MainPage' },
            _react2.default.createElement(_reactDocumentMeta2.default, Meta),
            _react2.default.createElement(_Header2.default, null),
            _react2.default.createElement(_DownloadSection2.default, null),
            _react2.default.createElement(_SnappServicesSection2.default, null),
            _react2.default.createElement(_SnappIntro2.default, null),
            _react2.default.createElement(_SnappFeatures2.default, { pages: _SnappFeatures4.default }),
            _react2.default.createElement(_Footer2.default, null)
        );
    }
});

module.exports = MainPage;

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(5);
var factory = __webpack_require__(113);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getDeviceInfo() {
    var _this = this;

    this.res = {};
    this.res.isPhone = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    this.res.width = window.innerWidth;
    this.res.height = window.innerHeight;
    this.res.isSmall = window.innerWidth < 900;

    this.listeners = [];

    document.addEventListener('resize', function () {
        _this.res.width = window.innerWidth;
        _this.res.height = window.innerHeight;
        _this.res.isSmall = window.innerWidth < 900;
        _this.listeners.map(function (func) {
            try {
                func(_this.res);
            } catch (e) {}
        });
    });

    this.addListener = function (func) {
        _this.listeners.push(func);
    };
}

module.exports = getDeviceInfo;

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.clone = clone;
exports.defaults = defaults;
exports.forEach = forEach;
function clone(_ref) {
  var title = _ref.title,
      description = _ref.description,
      base = _ref.base,
      canonical = _ref.canonical,
      meta = _ref.meta,
      link = _ref.link,
      auto = _ref.auto;

  try {
    return JSON.parse(JSON.stringify({ title: title, description: description, base: base, canonical: canonical, meta: meta, link: link, auto: auto }));
  } catch (x) {
    return {};
  }
}

function defaults(target, source) {
  return Object.keys(source).reduce(function (acc, key) {
    if (!target.hasOwnProperty(key)) {
      target[key] = source[key];
    } else if (_typeof(target[key]) === 'object' && !Array.isArray(target[key]) && target[key]) {
      defaults(target[key], source[key]);
    }

    return target;
  }, target);
}

function forEach(arr, fn) {
  Array.prototype.slice.call(arr || []).forEach(fn);
}


/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(275);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _DownloadButton = __webpack_require__(281);

var _DownloadButton2 = _interopRequireDefault(_DownloadButton);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ScreenSizeDetector = __webpack_require__(277);

var _ScreenSizeDetector2 = _interopRequireDefault(_ScreenSizeDetector);

var _HeaderLinks = __webpack_require__(282);

var _HeaderLinks2 = _interopRequireDefault(_HeaderLinks);

var _classnames = __webpack_require__(278);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseUrl = "../../../../assets/images/svg/";
var Header = (0, _createReactClass2.default)({
  displayName: "Header",
  propTypes: {
    hideDownload: _propTypes2.default.bool,
    logout: _propTypes2.default.string,
    logoutCallback: _propTypes2.default.func
  },
  getInitialState: function getInitialState() {
    return {
      isSmall: false,
      isOpen: false
    };
  },
  resized: function resized(newSize) {
    this.setState({
      isSmall: newSize.isSmall
    });
  },
  componentWillMount: function componentWillMount() {
    var sc = new _ScreenSizeDetector2.default();
    sc.addListener(this.resized);
    this.setState({
      isSmall: sc.res.isSmall
    });
  },
  render: function render() {
    return _react2.default.createElement(
      "div",
      {
        className: "Header",
        style: { paddingBottom: this.state.isOpen ? 0 : null }
      },
      !this.state.isSmall && _react2.default.createElement(
        "div",
        { className: "Section-right" },
        _react2.default.createElement(
          "a",
          { href: "/" },
          _react2.default.createElement(
            "div",
            { className: "Logo" },
            _react2.default.createElement("img", { src: "/assets/images/logo/logo.png", alt: "\u0627\u0633\u0646\u067E" })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "Options" },
          _react2.default.createElement(
            "ul",
            null,
            _HeaderLinks2.default.map(function (item, index) {
              return _react2.default.createElement(
                "li",
                { className: item.className, key: index },
                _react2.default.createElement(
                  "a",
                  { href: item.link, target: item.target },
                  item.title
                )
              );
            })
          )
        )
      ),
      this.state.isSmall && _react2.default.createElement(
        "div",
        { className: "Section-right" },
        _react2.default.createElement(
          "div",
          {
            className: (0, _classnames2.default)("Menu-Button", this.state.isOpen && "cross"),
            onClick: this.openMenu
          },
          this.state.isOpen ? _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement("img", {
              src: baseUrl + "close.svg",
              className: "Menu-button cross"
            })
          ) : _react2.default.createElement(
            "div",
            { className: "section" },
            _react2.default.createElement("div", { className: "HLine" }),
            _react2.default.createElement("div", { className: "HLine" }),
            _react2.default.createElement("div", { className: "HLine" })
          )
        ),
        _react2.default.createElement(
          "a",
          { href: "/" },
          _react2.default.createElement(
            "div",
            { className: "Logo" },
            _react2.default.createElement("img", { src: "/assets/images/logo/logo.png", alt: "\u0627\u0633\u0646\u067E" })
          )
        )
      ),
      !this.props.hideDownload && !this.props.logout && _react2.default.createElement(_DownloadButton2.default, null),
      this.props.logout && _react2.default.createElement(
        "div",
        { className: "DownloadButton", onClick: this.props.logoutCallback },
        _react2.default.createElement("i", { className: "icon icon-logout" }),
        _react2.default.createElement(
          "div",
          null,
          "\u062E\u0631\u0648\u062C"
        )
      ),
      _react2.default.createElement(
        "div",
        { className: "Menu-Items" + (this.state.isOpen ? " Open-Menu" : "") },
        _react2.default.createElement(
          "ul",
          null,
          _HeaderLinks2.default.map(function (item, index) {
            return _react2.default.createElement(
              "li",
              { key: index },
              _react2.default.createElement(
                "span",
                null,
                _react2.default.createElement(
                  "a",
                  { href: item.link, target: item.target },
                  item.title
                )
              )
            );
          })
        )
      )
    );
  },
  openMenu: function openMenu() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
});

module.exports = Header;

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(275);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DownloadButton = (0, _createReactClass2.default)({
  render: function render() {
    return _react2.default.createElement(
      "a",
      { className: "btn-link", href: "/driver-app" },
      _react2.default.createElement(
        "div",
        { className: "DownloadButton" },
        _react2.default.createElement(
          "div",
          { className: "btn" },
          "\u062F\u0631\u06CC\u0627\u0641\u062A \u0627\u0633\u0646\u067E \u0631\u0627\u0646\u0646\u062F\u06AF\u0627\u0646"
        )
      )
    );
  }
});

module.exports = DownloadButton;

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = [{
  title: "بلاگ",
  link: "/blog"
}, {
  title: "فرصت‌های شغلی",
  link: "https://career.snapp.ir"
}, {
  title: "درباره ما",
  link: "/about"
}, {
  title: "تماس با ما",
  link: "/contact"
}, {
  title: "پیوستن به ناوگان اسنپ",
  link: "https://digitalsignup.snapp.ir/?utm_source=snapp.ir&utm_medium=website-button&utm_campaign=ws-redirect-august2021"
}, {
  title: "پنل سازمانی",
  link: "https://corporate.snapp.ir",
  target: "_blank"
}, {
  title: "باشگاه رانندگان",
  link: "https://club.snapp.ir",
  target: "_blank",
  className: "club"
}];

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _FooterSocialLinks = __webpack_require__(284);

var _FooterSocialLinks2 = _interopRequireDefault(_FooterSocialLinks);

var _createReactClass = __webpack_require__(275);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = (0, _createReactClass2.default)({
    render: function render() {
        return _react2.default.createElement(
            'div',
            { className: 'Footer' },
            _react2.default.createElement(
                'div',
                { className: 'Links' },
                _react2.default.createElement(
                    'a',
                    { className: 'Item Active', href: '/download' },
                    '\u062F\u0631\u06CC\u0627\u0641\u062A \u0627\u0633\u0646\u067E'
                ),
                _react2.default.createElement(
                    'a',
                    { className: 'Item', href: '/career' },
                    '\u0641\u0631\u0635\u062A\u200C\u0647\u0627\u06CC \u0634\u063A\u0644\u06CC'
                ),
                _react2.default.createElement(
                    'a',
                    { className: 'Item', href: '/terms' },
                    '\u0634\u0631\u0627\u06CC\u0637 \u0648 \u0642\u0648\u0627\u0646\u06CC\u0646'
                ),
                _react2.default.createElement(
                    'a',
                    { className: 'Item', href: '/policy' },
                    '\u062D\u0631\u06CC\u0645 \u062E\u0635\u0648\u0635\u06CC'
                ),
                _react2.default.createElement(
                    'a',
                    { className: 'Item', href: '/about' },
                    '\u062F\u0631\u0628\u0627\u0631\u0647 \u0645\u0627'
                ),
                _react2.default.createElement(
                    'a',
                    { className: 'Item', href: '/contact' },
                    '\u062A\u0645\u0627\u0633 \u0628\u0627 \u0645\u0627'
                ),
                _react2.default.createElement(
                    'a',
                    { className: 'Item', href: '/faq' },
                    '\u0633\u0648\u0627\u0644\u0627\u062A \u0645\u062A\u062F\u0627\u0648\u0644'
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'Copyright' },
                '\xA9\u06A9\u067E\u06CC \u0631\u0627\u06CC\u062A \u062A\u0645\u0627\u0645\u06CC \u062D\u0642\u0648\u0642 \u0645\u0627\u062F\u06CC \u0648 \u0645\u0639\u0646\u0648\u06CC \u0627\u06CC\u0646 \u0633\u0631\u0648\u06CC\u0633 (\u0648\u0628 \u0633\u0627\u06CC\u062A \u0648 \u0627\u067E\u0644\u06CC\u06A9\u06CC\u0634\u0646 \u0647\u0627\u06CC \u0645\u0648\u0628\u0627\u06CC\u0644) \u0645\u062A\u0639\u0644\u0642 \u0628\u0647 \u0627\u06CC\u062F\u0647 \u06AF\u0632\u06CC\u0646 \u0627\u0631\u062A\u0628\u0627\u0637\u0627\u062A \u0631\u0648\u0645\u0627\u06A9 (\u0627\u0633\u0646\u067E) \u0627\u0633\u062A.'
            ),
            _react2.default.createElement(_FooterSocialLinks2.default, null),
            _react2.default.createElement(
                'div',
                { className: 'Organs' },
                _react2.default.createElement('img', { id: 'rgvjjzpefukzjxlznbqe',
                    style: { cursor: 'pointer' },
                    onClick: function onClick() {
                        window.open('https://logo.samandehi.ir/Verify.aspx?id=37612&p=xlaojyoegvkarfthuiwk', 'Popup', 'toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30');
                    },
                    alt: 'logo-samandehi',
                    src: 'https://logo.samandehi.ir/logo.aspx?id=37612&p=qftiyndtwlbqnbpdodrf' }),
                _react2.default.createElement('img', { src: 'https://trustseal.enamad.ir/logo.aspx?id=30599&p=vjymgthvfujyzpfvzpfv',
                    alt: '\u0646\u0645\u0627\u062F \u0627\u0639\u062A\u0645\u0627\u062F \u0627\u0644\u06A9\u062A\u0631\u0648\u0646\u06CC\u06A9\u06CC', onClick: function onClick() {
                        window.open('https://trustseal.enamad.ir/Verify.aspx?id=30599&p=fuixdrfsyncrjzpgjzpg', 'Popup', 'toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30');
                    } }),
                _react2.default.createElement('img', { src: 'https://ecunion.ir/bundles/pouyasoft/home/img/namad.png',
                    alt: 'ecunion',
                    style: { cursor: 'pointer', backgroundColor: '#fff', padding: '10px' },
                    onClick: function onClick() {
                        window.open('https://ecunion.ir/verify/snapp.ir?token=37368045acf0232aa0c3', 'Popup', 'toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30');
                    } })
            )
        );
    }
});

module.exports = Footer;

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(275);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var socials = [{
  url: 'http://bit.ly/2rBrcYMTwtr',
  className: 'icon-twitter-box'
}, {
  url: 'http://bit.ly/2pV8pdLTlgrm',
  className: 'icon-telegram'
}, {
  url: 'http://bit.ly/2qATyUIFB',
  className: 'icon-facebook-box'
}, {
  url: 'http://bit.ly/2qAY2dUINST',
  className: 'icon-instagram'
}, {
  url: 'http://bit.ly/2pVeQ0rAPRT',
  className: 'icon-aparat'
}];
var FooterSocialLinks = (0, _createReactClass2.default)({
  render: function render() {
    return _react2.default.createElement(
      'div',
      { className: 'Social-Links' },
      socials.map(function (item) {
        return _react2.default.createElement(
          'span',
          { key: item.url },
          _react2.default.createElement(
            'a',
            { href: item.url, target: '_blank' },
            _react2.default.createElement('i', { className: item.className })
          )
        );
      })
    );
  }
});

module.exports = FooterSocialLinks;

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ServerConfig = __webpack_require__(286);

var _ServerConfig2 = _interopRequireDefault(_ServerConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formDataToObject(data) {
  var result = {};
  try {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = data.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        result[key] = data.get(key);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return result;
  } catch (e) {
    return data;
  }
}
var ServerCalls = {
  SendRequest: function SendRequest(Method, Address, Token, Params, CallBack) {
    var xhttp = new XMLHttpRequest();
    var str = "";
    if (Method.toLowerCase() === "get" && Params) str = "?" + Object.keys(Params).map(function (prop) {
      return [prop, Params[prop]].map(encodeURIComponent).join("=");
    }).join("&");
    xhttp.open(Method, Address + str, true);
    xhttp.setRequestHeader("Accept", "application/json");
    xhttp.onreadystatechange = function () {
      if (xhttp.readyState === 4) {
        if (xhttp.status === 200) {
          var Respond = xhttp.responseText;
          var ReqRes = JSON.parse(Respond);
          CallBack(ReqRes);
        } else {
          var _Respond = xhttp.responseText;
          var _ReqRes = {};
          try {
            _ReqRes = JSON.parse(_Respond);
          } catch (e) {
            _ReqRes = {};
            _ReqRes.status = xhttp.status;
          }
          CallBack(_ReqRes);
        }
      }
    };
    xhttp.onerror = function () {
      var Respond = xhttp.responseText;
      CallBack({ status: xhttp.status, message: Respond });
    };
    if (Token && Token !== null) xhttp.setRequestHeader("Authorization", Token);
    if (Params instanceof FormData) {
      xhttp.send(Params);
    } else {
      xhttp.setRequestHeader("Content-Type", "application/json");
      xhttp.send(JSON.stringify(Params));
    }
  },
  getLandingData: function getLandingData(name, cb) {
    ServerCalls.SendRequest("GET", _ServerConfig2.default.LandingServer + "/get", null, { tag: name }, cb);
  },
  getCareerJobs: function getCareerJobs(cb) {
    ServerCalls.SendRequest("POST", _ServerConfig2.default.CareerServer + "/all", null, null, cb);
  },
  getCareerJob: function getCareerJob(jobTag, cb) {
    ServerCalls.SendRequest("POST", _ServerConfig2.default.CareerServer + "/get", null, { jobTag: jobTag }, cb);
  },
  applyJob: function applyJob(data, cb) {
    var xhttp = new XMLHttpRequest();
    xhttp.open("POST", _ServerConfig2.default.CareerServer + "/sign_up", true);
    xhttp.onreadystatechange = function () {
      if (xhttp.readyState === 4 && xhttp.status === 200) {
        cb(JSON.parse(xhttp.responseText));
      }
    };
    xhttp.send(data);
  },
  sendContact: function sendContact(data, cb) {
    ServerCalls.SendRequest("POST", _ServerConfig2.default.ContactServer + "/send", null, data, cb);
  },
  sendSms: function sendSms(data, cb) {
    ServerCalls.SendRequest("POST", _ServerConfig2.default.SmsServer + "/link", null, data, cb);
  },
  getGroupedCategory: function getGroupedCategory(CallBack) {
    ServerCalls.SendRequest("GET", _ServerConfig2.default.FaqServer + "/all", false, null, CallBack);
  },
  getTypeFaqs: function getTypeFaqs(type, CallBack) {
    ServerCalls.SendRequest("GET", _ServerConfig2.default.FaqServer + "/type", false, { type: type }, CallBack);
  },
  searchTypeFaqs: function searchTypeFaqs(type, words, CallBack) {},
  searchFaqs: function searchFaqs(type, words, CallBack) {
    ServerCalls.SendRequest("POST", _ServerConfig2.default.FaqServer + "/search", false, { words: words, type: type }, CallBack);
  },
  getEducationPosts: function getEducationPosts(CallBack) {
    ServerCalls.SendRequest("GET", _ServerConfig2.default.EducationServer + "/all_posts", null, null, CallBack);
  },
  getEducationCategoryPosts: function getEducationCategoryPosts(tag, CallBack) {
    ServerCalls.SendRequest("GET", _ServerConfig2.default.EducationServer + "/category_posts", null, { tag: tag }, CallBack);
  },
  getEducationTypePosts: function getEducationTypePosts(id, CallBack) {
    ServerCalls.SendRequest("GET", _ServerConfig2.default.EducationServer + "/type_posts", null, { id: id }, CallBack);
  },
  getEducationPost: function getEducationPost(data, CallBack) {
    ServerCalls.SendRequest("POST", _ServerConfig2.default.EducationServer + "/get_post", null, data, CallBack);
  },
  signUpEducation: function signUpEducation(data, CallBack) {
    ServerCalls.SendRequest("POST", _ServerConfig2.default.EducationServer + "/sign_in", null, data, CallBack);
  },
  verifyEducation: function verifyEducation(data, CallBack) {
    ServerCalls.SendRequest("POST", _ServerConfig2.default.EducationServer + "/verify", null, data, CallBack);
  },
  searchEducationPosts: function searchEducationPosts(words, CallBack) {
    ServerCalls.SendRequest("GET", _ServerConfig2.default.EducationServer + "/search_posts", null, { words: words }, CallBack);
  },
  signInBanning: function signInBanning(data, CallBack) {
    ServerCalls.SendRequest("POST", _ServerConfig2.default.BanningServer + "/sign_in", null, data, CallBack);
  },
  verifyBanning: function verifyBanning(data, CallBack) {
    ServerCalls.SendRequest("POST", _ServerConfig2.default.BanningServer + "/verify", null, data, CallBack);
  },
  getBanningRecords: function getBanningRecords(data, CallBack) {
    ServerCalls.SendRequest("POST", _ServerConfig2.default.BanningServer + "/get_records", null, data, CallBack);
  },
  getPromotersConfig: function getPromotersConfig(CallBack) {
    ServerCalls.SendRequest("GET", _ServerConfig2.default.PromoterServer + "/public/config", null, null, CallBack);
  },
  loginPromoters: function loginPromoters(data, CallBack) {
    ServerCalls.SendRequest("POST", _ServerConfig2.default.PromoterServer + "/promoters/sign-in", null, data, CallBack);
  },
  searchDriversPromoter: function searchDriversPromoter(data, token, CallBack) {
    ServerCalls.SendRequest("GET", _ServerConfig2.default.PromoterServer + "/drivers/search", "bearer " + token, data, CallBack);
  },
  getPromoterDriverProfile: function getPromoterDriverProfile(data, token, CallBack) {
    ServerCalls.SendRequest("GET", _ServerConfig2.default.PromoterServer + "/drivers/profile", "bearer " + token, data, CallBack);
  },
  signUpPromoterDriver: function signUpPromoterDriver(data, CallBack) {
    ServerCalls.SendRequest("POST", _ServerConfig2.default.PromoterServer + "/drivers/sign-up", null, data, CallBack);
  },
  verifyPromoterDriver: function verifyPromoterDriver(data, token, CallBack) {
    ServerCalls.SendRequest("POST", _ServerConfig2.default.PromoterServer + "/drivers/profile", "bearer " + token, data, CallBack);
  },
  verifyPromoterFinal: function verifyPromoterFinal(data, token, CallBack) {
    ServerCalls.SendRequest("POST", _ServerConfig2.default.PromoterServer + "/documents/verify", "bearer " + token, data, CallBack);
  },
  uploadPromoterDoc: function uploadPromoterDoc(data, token, CallBack) {
    ServerCalls.SendRequest("POST", _ServerConfig2.default.PromoterServer + "/documents/upload", "bearer " + token, data, CallBack);
  },
  getCurrentDate: function getCurrentDate(CallBack) {
    ServerCalls.SendRequest("GET", _ServerConfig2.default.GeneralServer + "/getcurrentdate", null, null, CallBack);
  },
  getCityData: function getCityData(CallBack) {
    ServerCalls.SendRequest("GET", _ServerConfig2.default.GeneralServerV2 + "/cities", null, null, CallBack);
  },
  submitDriver: function submitDriver(data, cb) {
    ServerCalls.SendRequest("POST", _ServerConfig2.default.GeneralServerV2 + "/driver/sign_up", null, data, cb);
  },
  driverAppSmsLink: function driverAppSmsLink(data, cb) {
    ServerCalls.SendRequest("POST", _ServerConfig2.default.GeneralServer + "/sms/link", null, data, cb);
  },
  getApkDownloadUrl: function getApkDownloadUrl(CallBack) {
    ServerCalls.SendRequest("GET", _ServerConfig2.default.GeneralServerV2 + "/app-url", null, null, CallBack);
  }
};

module.exports = ServerCalls;

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var url = undefined ? undefined : "https://api.snapp.ir";
module.exports = {
  LandingServer: url + "/api/v1/campaign",
  ServerMedia: url + "/storage/uploads/",
  CareerServer: url + "/api/v1/career",
  ContactServer: url + "/api/v1/contact",
  SmsServer: url + "/api/v1/sms",
  DriversServer: url + "/api/v1/driver",
  FaqServer: url + "/api/v1/faq",
  EducationServer: url + "/api/v1/education",
  BanningServer: url + "/api/v1/banning",
  GeneralServer: url + "/api/v1",
  PromoterServer: "https://promoters.snapp.ir/api/v1",
  GeneralServerV2: url + "/api/v2"
};

// "https://api.snapp.ir"
//https://snapp-drivers-laravel-snapp-ode-mozart.apps.private.teh-1.snappcloud.io/

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;
exports.removeDocumentMeta = removeDocumentMeta;
exports.insertDocumentMeta = insertDocumentMeta;

var _utils = __webpack_require__(279);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function removeNode(node) {
  node.parentNode.removeChild(node);
}

function removeDocumentMeta() {
  (0, _utils.forEach)(document.querySelectorAll('head [data-rdm]'), removeNode);
}

function insertDocumentMetaNode(entry) {
  var tagName = entry.tagName,
      attr = _objectWithoutProperties(entry, ['tagName']);

  var newNode = document.createElement(tagName);
  for (var prop in attr) {
    if (entry.hasOwnProperty(prop)) {
      newNode.setAttribute(prop, entry[prop]);
    }
  }
  newNode.setAttribute('data-rdm', '');
  document.getElementsByTagName('head')[0].appendChild(newNode);
}

function insertDocumentMeta(nodes) {
  removeDocumentMeta();

  (0, _utils.forEach)(nodes, insertDocumentMetaNode);
}


/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _server = __webpack_require__(295);

var _reactSideEffect = __webpack_require__(290);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _utils = __webpack_require__(279);

var _dom = __webpack_require__(287);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function reducePropsTostate(propsList) {
  var props = {};

  var extend = true;

  for (var i = propsList.length - 1; extend && i >= 0; i--) {
    extend = propsList[i].hasOwnProperty('extend');

    var _props = (0, _utils.clone)(propsList[i]);

    if (_props.hasOwnProperty('description')) {
      (0, _utils.defaults)(_props, { meta: { name: { description: _props.description } } });
    }
    if (_props.hasOwnProperty('canonical')) {
      (0, _utils.defaults)(_props, { link: { rel: { canonical: _props.canonical } } });
    }

    (0, _utils.defaults)(props, _props);
  }

  // Auto props
  if (props.auto) {
    if (props.auto.ograph) {
      ograph(props);
    }
  }

  return props;
}

function handleStateChangeOnClient(props) {
  if (_dom.canUseDOM) {
    document.title = props.title || '';
    (0, _dom.insertDocumentMeta)(getTags(props));
  }
}

function ograph(p) {
  if (!p.meta) {
    p.meta = {};
  }
  if (!p.meta.property) {
    p.meta.property = {};
  }

  var group = p.meta.property;
  if (group) {
    if (p.title && !group['og:title']) {
      group['og:title'] = p.title;
    }
    if (p.hasOwnProperty('description') && !group['og:description']) {
      group['og:description'] = p.description;
    }
    if (p.hasOwnProperty('canonical') && !group['og:url']) {
      group['og:url'] = p.canonical;
    }
  }
  return p;
}

function parseTags(tagName) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var tags = [];
  var contentKey = tagName === 'link' ? 'href' : 'content';
  Object.keys(props).forEach(function (groupKey) {
    var group = props[groupKey];
    if (typeof group === 'string') {
      tags.push(_defineProperty({
        tagName: tagName
      }, groupKey, group));
      return;
    }
    Object.keys(group).forEach(function (key) {
      var values = Array.isArray(group[key]) ? group[key] : [group[key]];
      values.forEach(function (value) {
        if (value !== null) {
          var _tags$push2;

          tags.push((_tags$push2 = {
            tagName: tagName
          }, _defineProperty(_tags$push2, groupKey, key), _defineProperty(_tags$push2, contentKey, value), _tags$push2));
        }
      });
    });
  });
  return tags;
}

function getTags(_props) {
  return [].concat(parseTags('meta', _props.meta), parseTags('link', _props.link));
}

function render() {
  var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var opts = arguments[1];

  if ((typeof opts === 'undefined' ? 'undefined' : _typeof(opts)) !== 'object') {
    return meta;
  }

  var i = 0;
  var tags = [];

  function renderTag(entry) {
    var tagName = entry.tagName,
        attr = _objectWithoutProperties(entry, ['tagName']);

    if (tagName === 'meta') {
      return _react2.default.createElement('meta', _extends({}, attr, { key: i++, 'data-rdm': true }));
    }
    if (tagName === 'link') {
      return _react2.default.createElement('link', _extends({}, attr, { key: i++, 'data-rdm': true }));
    }
    return null;
  }

  if (meta.title) {
    tags.push(_react2.default.createElement(
      'title',
      { key: i++ },
      meta.title
    ));
  }

  getTags(meta).reduce(function (acc, entry) {
    tags.push(renderTag(entry));
    return tags;
  }, tags);

  if (opts.asReact) {
    return tags;
  }

  return (0, _server.renderToStaticMarkup)(_react2.default.createElement(
    'div',
    null,
    tags
  )).replace(/(^<div>|<\/div>$)/g, '').replace(/data-rdm="true"/g, 'data-rdm');
}

var DocumentMeta = function (_Component) {
  _inherits(DocumentMeta, _Component);

  function DocumentMeta() {
    _classCallCheck(this, DocumentMeta);

    return _possibleConstructorReturn(this, (DocumentMeta.__proto__ || Object.getPrototypeOf(DocumentMeta)).apply(this, arguments));
  }

  _createClass(DocumentMeta, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;

      var count = _react2.default.Children.count(children);
      return count === 1 ? _react2.default.Children.only(children) : count ? _react2.default.createElement(
        'div',
        null,
        this.props.children
      ) : null;
    }
  }]);

  return DocumentMeta;
}(_react.Component);

DocumentMeta.propTypes = {
  title: _propTypes2.default.string,
  description: _propTypes2.default.string,
  base: _propTypes2.default.string,
  canonical: _propTypes2.default.string,
  meta: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]))])),
  link: _propTypes2.default.objectOf(_propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]))),
  auto: _propTypes2.default.objectOf(_propTypes2.default.bool)
};


var DocumentMetaWithSideEffect = (0, _reactSideEffect2.default)(reducePropsTostate, handleStateChangeOnClient)(DocumentMeta);

DocumentMetaWithSideEffect.renderAsReact = function rewindAsReact() {
  return render(DocumentMetaWithSideEffect.rewind(), { asReact: true });
};

DocumentMetaWithSideEffect.renderAsHTML = function rewindAsHTML() {
  return render(DocumentMetaWithSideEffect.rewind(), { asHtml: true });
};

DocumentMetaWithSideEffect.renderToStaticMarkup = function rewindAsHTML() {
  return render(DocumentMetaWithSideEffect.rewind(), { asHtml: true });
};

exports.default = DocumentMetaWithSideEffect;
module.exports = exports['default'];


/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(289);

var _exenv2 = _interopRequireDefault(_exenv);

var _shallowequal = __webpack_require__(291);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !(0, _shallowequal2.default)(nextProps, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(_react.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = _exenv2.default.canUseDOM;


    return SideEffect;
  };
};

/***/ }),

/***/ 291:
/***/ (function(module, exports) {

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if(ret !== void 0) {
        return !!ret;
    }

    if(objA === objB) {
        return true;
    }

    if(typeof objA !== 'object' || !objA ||
       typeof objB !== 'object' || !objB) {
        return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);

    if(keysA.length !== keysB.length) {
        return false;
    }

    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++) {

        var key = keysA[idx];

        if(!bHasOwnProperty(key)) {
            return false;
        }

        var valueA = objA[key];
        var valueB = objB[key];

        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

        if(ret === false ||
           ret === void 0 && valueA !== valueB) {
            return false;
        }

    }

    return true;

};


/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDefaultInjection = __webpack_require__(116);
var ReactServerRendering = __webpack_require__(294);
var ReactVersion = __webpack_require__(119);

ReactDefaultInjection.inject();

var ReactDOMServer = {
  renderToString: ReactServerRendering.renderToString,
  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
  version: ReactVersion
};

module.exports = ReactDOMServer;

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactServerBatchingStrategy = {
  isBatchingUpdates: false,
  batchedUpdates: function (callback) {
    // Don't do anything here. During the server rendering we don't want to
    // schedule any updates. We will simply ignore them.
  }
};

module.exports = ReactServerBatchingStrategy;

/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(1);

var React = __webpack_require__(16);
var ReactDOMContainerInfo = __webpack_require__(114);
var ReactDefaultBatchingStrategy = __webpack_require__(115);
var ReactInstrumentation = __webpack_require__(8);
var ReactMarkupChecksum = __webpack_require__(117);
var ReactReconciler = __webpack_require__(15);
var ReactServerBatchingStrategy = __webpack_require__(293);
var ReactServerRenderingTransaction = __webpack_require__(118);
var ReactUpdates = __webpack_require__(9);

var emptyObject = __webpack_require__(65);
var instantiateReactComponent = __webpack_require__(64);
var invariant = __webpack_require__(0);

var pendingTransactions = 0;

/**
 * @param {ReactElement} element
 * @return {string} the HTML markup
 */
function renderToStringImpl(element, makeStaticMarkup) {
  var transaction;
  try {
    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);

    transaction = ReactServerRenderingTransaction.getPooled(makeStaticMarkup);

    pendingTransactions++;

    return transaction.perform(function () {
      var componentInstance = instantiateReactComponent(element, true);
      var markup = ReactReconciler.mountComponent(componentInstance, transaction, null, ReactDOMContainerInfo(), emptyObject, 0 /* parentDebugID */
      );
      if (false) {
        ReactInstrumentation.debugTool.onUnmountComponent(componentInstance._debugID);
      }
      if (!makeStaticMarkup) {
        markup = ReactMarkupChecksum.addChecksumToMarkup(markup);
      }
      return markup;
    }, null);
  } finally {
    pendingTransactions--;
    ReactServerRenderingTransaction.release(transaction);
    // Revert to the DOM batching strategy since these two renderers
    // currently share these stateful modules.
    if (!pendingTransactions) {
      ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
    }
  }
}

/**
 * Render a ReactElement to its initial HTML. This should only be used on the
 * server.
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostring
 */
function renderToString(element) {
  !React.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : _prodInvariant('46') : void 0;
  return renderToStringImpl(element, false);
}

/**
 * Similar to renderToString, except this doesn't create extra DOM attributes
 * such as data-react-id that React uses internally.
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostaticmarkup
 */
function renderToStaticMarkup(element) {
  !React.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : _prodInvariant('47') : void 0;
  return renderToStringImpl(element, true);
}

module.exports = {
  renderToString: renderToString,
  renderToStaticMarkup: renderToStaticMarkup
};

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(292);


/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    MainPage: {
        title: 'اسنپ | سامانه هوشمند حمل‌ونقل | تاکسی اینترنتی',
        description: 'اسنپ اولین و بزرگ‌ترین تاکسی اینترنتی ایران است که امکان درخواست آنلاین خودرو را برای شما فراهم می‌کند. با اسنپ سفری آسان و مطمئن را تجربه کنید.',
        meta: {
            name: {
                keywords: 'تاکسی، تاکسی تلفنی، تاکسی اینترنتی، تاکسی آنلاین، تاکسی فرودگاه، تاکسی ارزان، تاکسی بیسیم، تاکسی تهران، تاکسی کرج، تاکسی بانوان، تاکسی شبانه روزی، قیمت تاکسی، نرخ تاکسی، کرایه تاکسی، کرایه ماشین، آژانس اینترنتی، آژانس ارزان، ایستگاه تاکسی، تلفن تاکسی، شماره تاکسی، رزرو تاکسی، آژانس شبانه روزی، تاکسیرانی، تاکسی تلفنی اینترنتی، تاکسی سرویس'
            }
        }
    },
    DownloadPage: {
        title: 'اسنپ | دانلود اپلیکیشن موبایل اسنپ - Snapp Apps',
        description: 'اپلیکیشن اسنپ این امکان را برای شما فراهم می‌سازد تا چند گام از دیگران جلوتر باشید و به صورت اینترنتی، تاکسی درخواست کنید.',
        meta: {
            name: {
                keywords: "دانلود اپلیکیشن تاکسی، دانلود اپلیکیشن، دانلود اسنپ، دانلود تپسی، دانلود نر افزار تاکسی، دانلود اپلیکیشن اسنپ، تاکسی، تاکسی آنلاین، تاکسی اینترنتی"
            }
        }
    },
    AboutPage: {
        title: '‌اسنپ | درباره ما',
        description: 'دنبال یک راه ساده و سریع برای درخواست خودرو هستید؟ اسنپ را از دست ندهید.',
        meta: {
            name: {
                keywords: ' درباره اسنپ، درباره تاکسی اینترنتی، تاکسی، تاکسی اینترنتی، تاکسی آنلاین، مجوز اسنپ، اسنپ، تاکسی یاب، تپسی، درباره تپسی، کارپینو'
            }
        }
    },
    ContactPage: {
        title: '‌اسنپ | تلفن پشتیبانی اسنپ و آدرس دفاتر اسنپ در سایر شهرها',
        description: 'اگر سوال و پیشنهاد یا انتقادی دارید، می‌توانید به صورت مستقیم با روابط عمومی اسنپ صحبت کنید. آدرس و شماره تلفن دفاتراسنپ را مشاهده کنید.',
        meta: {
            name: {
                keywords: ' تماس با اسنپ، تماس با ما، آدرس اسنپ، تلفن اسنپ، شماره اسنپ، پشتیبانی اسنپ، روابط عمومی اسنپ، تاکسی، تاکسی اینترنتی، تاکسی آنلاین'
            }
        }
    },
    CareerPage: {
        title: 'اسنپ - ‌فرصت‌های شغلی در اسنپ - Snapp',
        description: 'اسنپ همواره از نیروهای جوان و با انگیزه استقبال می‌کند.برای استخدام در اسنپ رزومه خود را به آدرس jobs@snapp.cab ارسال کنید.',
        meta: {
            name: {
                keywords: ' استخدام در اسنپ، استخدام در تپسی، فرصت های شغلی اسنپ، فرصت های شغلی تپسی، کار در اسنپ، تاکسی، تاکسی آنلاین، تاکسی اینترنتی، کار در استارت آپ'
            }
        }
    },
    TermsPage: {
        title: 'اسنپ | شرایط و قوانین',
        description: 'شرایط و قوانین استفاده از سرویس‌های اسنپ را مطالعه بفرمایید.'
    },
    BoxTermsPage: {
        title: 'اسنپ - شرایط و قوانین اسنپ‌باکس - Snapp',
        description: 'با اپلیکیشن اِسنَپ، در هر کجا که هستید به راحتی و با یک کلیک خودرو سفارش بدهید.'
    },
    PolicyPage: {
        title: 'اسنپ | حریم خصوصی',
        description: 'رعایت حریم شخصی کاربران برای اسنپ بسیار حائز اهمیت است.'
    },
    DriversPage: {
        title: 'اسنپ | ثبت نام راننده و دریافت اسنپ رانندگان - Snapp Driver',
        description: 'به خانواده اسنپ بپیوندید و به آسانی درآمد بالا کسب کنید.  با استفاده ازخودروی خود در ساعات کاری آزادتان، مسافرین اسنپ را به مقصد برسانید و کسب درآمد کنید.',
        meta: {
            name: {
                keywords: 'عضویت در اسنپ، راننده اسنپ، استخدام در اسنپ، ثبت نام در اسنپ، ثبت نام در تپسی، عضویت در تپسی، راننده تپسی، تاکسی، تاکسی آنلاین، تاکسی اینترنتی، راننده تاکسی'
            }
        }
    },
    FAQPage: {
        title: 'اسنپ | سوالات متداول',
        description: 'در این صفحه می توانید پاسخ به سوالات متداول مربوط به نحوه استفاده از اسنپ توسط کاربران اسنپ (مسافر) واستفاده از اپ همراهان (رانندگان) را جستجو کنید.',
        meta: {
            name: {
                keywords: 'سوالات متداول ، مسافر، درخواست خودرو، دانلود اسنپ، اسنپ اصفهان، اسنپ تهران، اسنپ کرج، اسنپ مشهد، اسنپ شیراز، اسنپ مشهد، تاکسی شیراز، تاکسی قم، تاکسی تبریز، تاکسی اهواز، راننده، اپلیکیشن،ثبت نام، تلفن همراه، اسنپ وان، اسنپ پلاس، اسنپ اکو، درخواست تاکسی، حمل و نقل، تاکسی تهران'
            }
        }
    },
    CorporateTermsPage: {
        title: 'اسنپ - شرایط و قوانین پنل سازمانی - Snapp'
    },
    CorporateFaqPage: {
        title: 'اسنپ - پنل سازمانی - Snapp'
    },
    EducationPage: {
        title: 'اسنپ - سامانه آموزش اسنپ - Snapp'
    },
    BanningPage: {
        title: 'اسنپ - سوابق مسدودی - Snapp'
    },
    LandingRose: {
        title: 'اسنپ رز:‌ سرویس ویژه بانوان',
        description: 'اسنپ وان - سرویس حمل و نقل اختصاصی برای بانوان',
        meta: {
            name: {
                keywords: 'اسنپ رز، تاکسی آنلاین، تاکسی اینترنتی، اپلیکیشن تاکسی، درخواست تاکسی، تاکسی تهران، تاکسی اصفهان، تاکسی شیراز، تاکسی قم، تاکسی مشهد، تامسی تبریز، تاکسی اهواز، تاکسی ارزان، تاکسی فرودگاه'
            }
        }
    },
    KishIslandLanding: {
        title: 'اسنپ',
        description: 'اسنپ: سامانه هوشمند حمل و نقل شهری',
        meta: {
            name: {
                keywords: 'اسنپ رُز، تاکسی آنلاین، تاکسی اینترنتی، اپلیکیشن تاکسی، درخواست تاکسی، تاکسی تهران، تاکسی اصفهان، تاکسی شیراز، تاکسی مشهد، تاکسی تبریز، تاکسی قم، تاکسی اهواز، تاکسی فرودگاه'
            }
        }
    },
    IOSTutorial: {
        title: 'اسنپ | راهنمای نصب اپلیکیشن برای آیفون - Snapp ios',
        description: 'دانلود اپلیکیشن اسنپ نسخه ios  همراه با راهنمای نصب برنامه بر روی گوشی‌های آیفون در چهار مرحله.',
        meta: {
            name: {
                keywords: 'اسنپ، اپلیکیشن، آیفون، اندروید، گوشی، تلفن همراه هوشمند، آی‌او‌اس، آیپد، تاکسی اینترنتی'
            }
        }
    },
    IOSTutorialSecondPage: {
        title: 'اسنپ | راهنمای نصب اپلیکیشن برای آیفون - Snapp ios',
        description: 'دانلود اپلیکیشن اسنپ نسخه ios  همراه با راهنمای نصب برنامه بر روی گوشی‌های آیفون در چهار مرحله.',
        meta: {
            name: {
                keywords: 'اسنپ، اپلیکیشن، آیفون، اندروید، گوشی، تلفن همراه هوشمند، آی‌او‌اس، آیپد، تاکسی اینترنتی',
                robots: "noindex"
            }
        }
    }
};

/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var englishNumbers = {
    '۰': '0',
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9'
};

var persianNumbers = {
    '0': '۰',
    '1': '۱',
    '2': '۲',
    '3': '۳',
    '4': '۴',
    '5': '۵',
    '6': '۶',
    '7': '۷',
    '8': '۸',
    '9': '۹'
};

module.exports = {
    deLocalize: function deLocalize(number) {
        var r = '';
        if ((typeof number === 'undefined' ? 'undefined' : _typeof(number)) !== _typeof('')) number = '' + number;
        for (var i = 0; i < number.length; ++i) {
            if (englishNumbers.hasOwnProperty(number[i])) r += englishNumbers[number[i]];else if (persianNumbers.hasOwnProperty(number[i])) r += number[i];else r += number[i];
        }return r;
    },
    Localize: function Localize(number) {
        var r = '';
        if ((typeof number === 'undefined' ? 'undefined' : _typeof(number)) !== _typeof('')) number = '' + number;
        for (var i = 0; i < number.length; ++i) {
            if (persianNumbers.hasOwnProperty(number[i])) r += persianNumbers[number[i]];else if (englishNumbers.hasOwnProperty(number[i])) r += number[i];else r += number[i];
        }return r;
    }
};

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UAParser = __webpack_require__(5);

var UA = exports.UA = new UAParser();

var browser = exports.browser = UA.getBrowser();
var cpu = exports.cpu = UA.getCPU();
var device = exports.device = UA.getDevice();
var engine = exports.engine = UA.getEngine();
var os = exports.os = UA.getOS();
var ua = exports.ua = UA.getUA();
var setUA = exports.setUA = function setUA(uaStr) {
  return UA.setUA(uaStr);
};

var mockUserAgent = exports.mockUserAgent = function mockUserAgent(userAgent) {
  window.navigator.__defineGetter__("userAgent", function () {
    return userAgent;
  });
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deviceDetect = undefined;

var _views = __webpack_require__(2);

Object.keys(_views).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _views[key];
    }
  });
});

var _selectors = __webpack_require__(4);

Object.keys(_selectors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _selectors[key];
    }
  });
});

var _detect = __webpack_require__(7);

var _detect2 = _interopRequireDefault(_detect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.deviceDetect = _detect2.default;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomView = exports.WearableView = exports.ConsoleView = exports.SmartTVView = exports.MobileOnlyView = exports.WinPhoneView = exports.TabletView = exports.MobileView = exports.IOSView = exports.IEView = exports.BrowserView = exports.AndroidView = undefined;

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AndroidView = exports.AndroidView = function AndroidView(props) {
  return props.device ? _react2.default.createElement(
    "div",
    { className: props.viewClassName, style: props.style },
    props.children
  ) : null;
};

var BrowserView = exports.BrowserView = function BrowserView(props) {
  return props.device ? _react2.default.createElement(
    "div",
    { className: props.viewClassName, style: props.style },
    props.children
  ) : null;
};

var IEView = exports.IEView = function IEView(props) {
  return props.device ? _react2.default.createElement(
    "div",
    { className: props.viewClassName, style: props.style },
    props.children
  ) : null;
};

var IOSView = exports.IOSView = function IOSView(props) {
  return props.device ? _react2.default.createElement(
    "div",
    { className: props.viewClassName, style: props.style },
    props.children
  ) : null;
};

var MobileView = exports.MobileView = function MobileView(props) {
  return props.device ? _react2.default.createElement(
    "div",
    { className: props.viewClassName, style: props.style },
    props.children
  ) : null;
};

var TabletView = exports.TabletView = function TabletView(props) {
  return props.device ? _react2.default.createElement(
    "div",
    { className: props.viewClassName, style: props.style },
    props.children
  ) : null;
};

var WinPhoneView = exports.WinPhoneView = function WinPhoneView(props) {
  return props.device ? _react2.default.createElement(
    "div",
    { className: props.viewClassName, style: props.style },
    props.children
  ) : null;
};

var MobileOnlyView = exports.MobileOnlyView = function MobileOnlyView(props) {
  return props.device ? _react2.default.createElement(
    "div",
    { className: props.viewClassName, style: props.style },
    props.children
  ) : null;
};

var SmartTVView = exports.SmartTVView = function SmartTVView(props) {
  return props.device ? _react2.default.createElement(
    "div",
    { className: props.viewClassName, style: props.style },
    props.children
  ) : null;
};

var ConsoleView = exports.ConsoleView = function ConsoleView(props) {
  return props.device ? _react2.default.createElement(
    "div",
    { className: props.viewClassName, style: props.style },
    props.children
  ) : null;
};

var WearableView = exports.WearableView = function WearableView(props) {
  return props.device ? _react2.default.createElement(
    "div",
    { className: props.viewClassName, style: props.style },
    props.children
  ) : null;
};

var CustomView = exports.CustomView = function CustomView(props) {
  return props.condition ? _react2.default.createElement(
    "div",
    { className: props.viewClassName, style: props.style },
    props.children
  ) : null;
};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(5);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUA = exports.engineVersion = exports.engineName = exports.mobileModel = exports.mobileVendor = exports.browserName = exports.browserVersion = exports.fullBrowserVersion = exports.osName = exports.osVersion = exports.isIE = exports.isOpera = exports.isSafari = exports.isFirefox = exports.isChrome = exports.isIOS = exports.isWinPhone = exports.isAndroid = exports.isBrowser = exports.isTablet = exports.isMobileOnly = exports.isMobile = exports.isChromium = exports.isMobileSafari = exports.isWearable = exports.isConsole = exports.isSmartTV = undefined;

var _getUaData = __webpack_require__(0);

var isMobileType = function isMobileType() {
  return _getUaData.device.type === "mobile" ? true : false;
};
var isTabletType = function isTabletType() {
  return _getUaData.device.type === "tablet" ? true : false;
};

var isMobileAndTabletType = function isMobileAndTabletType() {
  switch (_getUaData.device.type) {
    case "mobile":
      return true;
    case "tablet":
      return true;
    default:
      return false;
  }
};

var isSmartTVType = function isSmartTVType() {
  return _getUaData.device.type === "smarttv" ? true : false;
};
var isBrowserType = function isBrowserType() {
  return _getUaData.device.type === undefined ? true : false;
};
var isWearableType = function isWearableType() {
  return _getUaData.device.type === 'wearable' ? true : false;
};
var isConsoleType = function isConsoleType() {
  return _getUaData.device.type === 'console' ? true : false;
};
var isAndroidType = function isAndroidType() {
  return _getUaData.os.name === "Android" ? true : false;
};
var isWinPhoneType = function isWinPhoneType() {
  return _getUaData.os.name === "Windows Phone" ? true : false;
};
var isIOSType = function isIOSType() {
  return _getUaData.os.name === "iOS" ? true : false;
};
var isChromeType = function isChromeType() {
  return _getUaData.browser.name === "Chrome" ? true : false;
};
var isFirefoxType = function isFirefoxType() {
  return _getUaData.browser.name === "Firefox" ? true : false;
};
var isChromiumType = function isChromiumType() {
  return _getUaData.browser.name === 'Chromim' ? true : false;
};

var isSafariType = function isSafariType() {
  return _getUaData.browser.name === "Safari" || _getUaData.browser.name === "Mobile Safari" ? true : false;
};

var isMobileSafariType = function isMobileSafariType() {
  return _getUaData.browser.name === "Mobile Safari" ? true : false;
};
var isOperaType = function isOperaType() {
  return _getUaData.browser.name === "Opera" ? true : false;
};
var isIEType = function isIEType() {
  return _getUaData.browser.name === "Internet Explorer" ? true : false;
};

var getBrowserFullVersion = function getBrowserFullVersion() {
  return _getUaData.browser.major;
};
var getBrowserVersion = function getBrowserVersion() {
  return _getUaData.browser.version;
};
var getOsVersion = function getOsVersion() {
  return _getUaData.os.version ? _getUaData.os.version : "none";
};
var getOsName = function getOsName() {
  return _getUaData.os.name ? _getUaData.os.name : "none";
};
var getBrowserName = function getBrowserName() {
  return _getUaData.browser.name;
};
var getMobileVendor = function getMobileVendor() {
  return _getUaData.device.vendor ? _getUaData.device.vendor : "none";
};
var getMobileModel = function getMobileModel() {
  return _getUaData.device.model ? _getUaData.device.model : "none";
};
var getEngineName = function getEngineName() {
  return _getUaData.engine.name;
};
var getEngineVersion = function getEngineVersion() {
  return _getUaData.engine.version;
};
var getUseragent = function getUseragent() {
  return _getUaData.ua;
};

var isSmartTV = exports.isSmartTV = isSmartTVType();
var isConsole = exports.isConsole = isConsoleType();
var isWearable = exports.isWearable = isWearableType();
var isMobileSafari = exports.isMobileSafari = isMobileSafariType();
var isChromium = exports.isChromium = isChromiumType();
var isMobile = exports.isMobile = isMobileAndTabletType();
var isMobileOnly = exports.isMobileOnly = isMobileType();
var isTablet = exports.isTablet = isTabletType();
var isBrowser = exports.isBrowser = isBrowserType();
var isAndroid = exports.isAndroid = isAndroidType();
var isWinPhone = exports.isWinPhone = isWinPhoneType();
var isIOS = exports.isIOS = isIOSType();
var isChrome = exports.isChrome = isChromeType();
var isFirefox = exports.isFirefox = isFirefoxType();
var isSafari = exports.isSafari = isSafariType();
var isOpera = exports.isOpera = isOperaType();
var isIE = exports.isIE = isIEType();
var osVersion = exports.osVersion = getOsVersion();
var osName = exports.osName = getOsName();
var fullBrowserVersion = exports.fullBrowserVersion = getBrowserFullVersion();
var browserVersion = exports.browserVersion = getBrowserVersion();
var browserName = exports.browserName = getBrowserName();
var mobileVendor = exports.mobileVendor = getMobileVendor();
var mobileModel = exports.mobileModel = getMobileModel();
var engineName = exports.engineName = getEngineName();
var engineVersion = exports.engineVersion = getEngineVersion();
var getUA = exports.getUA = getUseragent();

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * UAParser.js v0.7.17
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
 * Dual licensed under GPLv2 & MIT
 */
(function(window,undefined){"use strict";var LIBVERSION="0.7.17",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded";var util={extend:function(regexes,extensions){var margedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){margedRegexes[i]=extensions[i].concat(regexes[i])}else{margedRegexes[i]=regexes[i]}}return margedRegexes},has:function(str1,str2){if(typeof str1==="string"){return str2.toLowerCase().indexOf(str1.toLowerCase())!==-1}else{return false}},lowerize:function(str){return str.toLowerCase()},major:function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,"").split(".")[0]:undefined},trim:function(str){return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}};var mapper={rgx:function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length==2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length==3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length==4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},str:function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(util.has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(util.has(map[i],str)){return i===UNKNOWN?undefined:i}}return str}};var maps={browser:{oldsafari:{version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}}},device:{amazon:{model:{"Fire Phone":["SD","KF"]}},sprint:{model:{"Evo Shift 4G":"7373KT"},vendor:{HTC:"APA",Sprint:"Sprint"}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2000:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"}}}};var regexes={browser:[[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,/(opera).+version\/([\w\.]+)/i,/(opera)[\/\s]+([\w\.]+)/i],[NAME,VERSION],[/(opios)[\/\s]+([\w\.]+)/i],[[NAME,"Opera Mini"],VERSION],[/\s(opr)\/([\w\.]+)/i],[[NAME,"Opera"],VERSION],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,/(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(rekonq)\/([\w\.]+)*/i,/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser)\/([\w\.-]+)/i],[NAME,VERSION],[/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i],[[NAME,"IE"],VERSION],[/(edge)\/((\d+)?[\w\.]+)/i],[NAME,VERSION],[/(yabrowser)\/([\w\.]+)/i],[[NAME,"Yandex"],VERSION],[/(puffin)\/([\w\.]+)/i],[[NAME,"Puffin"],VERSION],[/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],[[NAME,"UCBrowser"],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(micromessenger)\/([\w\.]+)/i],[[NAME,"WeChat"],VERSION],[/(QQ)\/([\d\.]+)/i],[NAME,VERSION],[/m?(qqbrowser)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/xiaomi\/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI Browser"]],[/;fbav\/([\w\.]+);/i],[VERSION,[NAME,"Facebook"]],[/headlesschrome(?:\/([\w\.]+)|\s)/i],[VERSION,[NAME,"Chrome Headless"]],[/\swv\).+(chrome)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 WebView"],VERSION],[/((?:oculus|samsung)browser)\/([\w\.]+)/i],[[NAME,/(.+(?:g|us))(.+)/,"$1 $2"],VERSION],[/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i],[VERSION,[NAME,"Android Browser"]],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/(dolfin)\/([\w\.]+)/i],[[NAME,"Dolphin"],VERSION],[/((?:android.+)crmo|crios)\/([\w\.]+)/i],[[NAME,"Chrome"],VERSION],[/(coast)\/([\w\.]+)/i],[[NAME,"Opera Coast"],VERSION],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,"Firefox"]],[/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w\.]+).+?(mobile\s?safari|safari)/i],[VERSION,NAME],[/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[[NAME,"GSA"],VERSION],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,mapper.str,maps.browser.oldsafari.version]],[/(konqueror)\/([\w\.]+)/i,/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape)\/([\w\.-]+)/i],[[NAME,"Netscape"],VERSION],[/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,/(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]+)*/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[NAME,VERSION]],cpu:[[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,util.lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/windows\s(ce|mobile);\sppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],[[ARCHITECTURE,/ower/,"",util.lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i],[[ARCHITECTURE,util.lowerize]]],device:[[/\((ipad|playbook);[\w\s\);-]+(rim|apple)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/applecoremedia\/[\w\.]+ \((ipad)/],[MODEL,[VENDOR,"Apple"],[TYPE,TABLET]],[/(apple\s{0,1}tv)/i],[[MODEL,"Apple TV"],[VENDOR,"Apple"]],[/(archos)\s(gamepad2?)/i,/(hp).+(touchpad)/i,/(hp).+(tablet)/i,/(kindle)\/([\w\.]+)/i,/\s(nook)[\w\s]+build\/(\w+)/i,/(dell)\s(strea[kpr\s\d]*[\dko])/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i],[[MODEL,mapper.str,maps.device.amazon.model],[VENDOR,"Amazon"],[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);.+(apple)/i],[MODEL,VENDOR,[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);/i],[MODEL,[VENDOR,"Apple"],[TYPE,MOBILE]],[/(blackberry)[\s-]?(\w+)/i,/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,/(hp)\s([\w\s]+\w)/i,/(asus)-?(\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/\(bb10;\s(\w+)/i],[MODEL,[VENDOR,"BlackBerry"],[TYPE,MOBILE]],[/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i],[MODEL,[VENDOR,"Asus"],[TYPE,TABLET]],[/(sony)\s(tablet\s[ps])\sbuild\//i,/(sony)?(?:sgp.+)\sbuild\//i],[[VENDOR,"Sony"],[MODEL,"Xperia Tablet"],[TYPE,TABLET]],[/android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i],[MODEL,[VENDOR,"Sony"],[TYPE,MOBILE]],[/\s(ouya)\s/i,/(nintendo)\s([wids3u]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/android.+;\s(shield)\sbuild/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation\s[34portablevi]+)/i],[MODEL,[VENDOR,"Sony"],[TYPE,CONSOLE]],[/(sprint\s(\w+))/i],[[VENDOR,mapper.str,maps.device.sprint.vendor],[MODEL,mapper.str,maps.device.sprint.model],[TYPE,MOBILE]],[/(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,/(zte)-(\w+)*/i,/(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/(nexus\s9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/d\/huawei([\w\s-]+)[;\)]/i,/(nexus\s6p)/i],[MODEL,[VENDOR,"Huawei"],[TYPE,MOBILE]],[/(microsoft);\s(lumia[\s\w]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/[\s\(;](xbox(?:\sone)?)[\s\);]/i],[MODEL,[VENDOR,"Microsoft"],[TYPE,CONSOLE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,"Microsoft"],[TYPE,MOBILE]],[/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,/mot[\s-]?(\w+)*/i,/(XT\d{3,4}) build\//i,/(nexus\s6)/i],[MODEL,[VENDOR,"Motorola"],[TYPE,MOBILE]],[/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],[MODEL,[VENDOR,"Motorola"],[TYPE,TABLET]],[/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],[[VENDOR,util.trim],[MODEL,util.trim],[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,"Samsung"],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,SMARTTV]],[/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,/((SM-T\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,TABLET]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV],MODEL],[/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,/(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,/sec-((sgh\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,MOBILE]],[/sie-(\w+)*/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/(maemo|nokia).*(n900|lumia\s\d+)/i,/(nokia)[\s_-]?([\w-]+)*/i],[[VENDOR,"Nokia"],MODEL,[TYPE,MOBILE]],[/android\s3\.[\s\w;-]{10}(a\d{3})/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/android.+([vl]k\-?\d{3})\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,TABLET]],[/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i],[[VENDOR,"LG"],MODEL,[TYPE,TABLET]],[/(lg) netcast\.tv/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/(nexus\s[45])/i,/lg[e;\s\/-]+(\w+)*/i,/android.+lg(\-?[\d\w]+)\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,MOBILE]],[/android.+(ideatab[a-z0-9\-\s]+)/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/linux;.+((jolla));/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/((pebble))app\/[\d\.]+\s/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/crkey/i],[[MODEL,"Chromecast"],[VENDOR,"Google"]],[/android.+;\s(glass)\s\d/i],[MODEL,[VENDOR,"Google"],[TYPE,WEARABLE]],[/android.+;\s(pixel c)\s/i],[MODEL,[VENDOR,"Google"],[TYPE,TABLET]],[/android.+;\s(pixel xl|pixel)\s/i],[MODEL,[VENDOR,"Google"],[TYPE,MOBILE]],[/android.+(\w+)\s+build\/hm\1/i,/android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,/android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d\w)?)\s+build/i,/android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+)?)\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,MOBILE]],[/android.+(mi[\s\-_]*(?:pad)?(?:[\s_]*[\w\s]+)?)\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,TABLET]],[/android.+;\s(m[1-5]\snote)\sbuild/i],[MODEL,[VENDOR,"Meizu"],[TYPE,TABLET]],[/android.+a000(1)\s+build/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/android.+[;\/]\s*(Venue[\d\s]*)\s+build/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i],[[VENDOR,"Barnes & Noble"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/android.+[;\/]\s*(zte)?.+(k\d{2})\s+build/i],[[VENDOR,"ZTE"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/android.+[;\/]\s*(zur\d{3})\s+build/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/(android).+[;\/]\s+([YR]\d{2}x?.*)\s+build/i,/android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(.+)\s+build/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(NS-?.+)\s+build/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/android.+[;\/]\s*((NX|Next)-?.+)\s+build/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/android.+[;\/]\s*(Xtreme\_?)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(LVTEL\-?)?(V1[12])\s+build/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(.*\b)\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*TU_(1491)\s+build/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/android.+(KS(.+))\s+build/i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/android.+(Gigaset)[\s\-]+(Q.+)\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/\s(tablet|tab)[;\/]/i,/\s(mobile)(?:[;\/]|\ssafari)/i],[[TYPE,util.lowerize],VENDOR,MODEL],[/(android.+)[;\/].+build/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[VERSION,[NAME,"EdgeHTML"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]+).*(gecko)/i],[VERSION,NAME]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[NAME,VERSION],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s]+\w)*/i,/(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],[NAME,[VERSION,mapper.str,maps.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,mapper.str,maps.os.windows.version]],[/\((bb)(10);/i],[[NAME,"BlackBerry"],VERSION],[/(blackberry)\w*\/?([\w\.]+)*/i,/(tizen)[\/\s]([\w\.]+)/i,/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,/linux;.+(sailfish);/i],[NAME,VERSION],[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i],[[NAME,"Symbian"],VERSION],[/\((series40);/i],[NAME],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[NAME,"Firefox OS"],VERSION],[/(nintendo|playstation)\s([wids34portablevu]+)/i,/(mint)[\/\s\(]?(\w+)*/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]+)*/i,/(hurd|linux)\s?([\w\.]+)*/i,/(gnu)\s?([\w\.]+)*/i],[NAME,VERSION],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(sunos)\s?([\w\.]+\d)*/i],[[NAME,"Solaris"],VERSION],[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i],[NAME,VERSION],[/(haiku)\s(\w+)/i],[NAME,VERSION],[/cfnetwork\/.+darwin/i,/ip[honead]+(?:.*os\s([\w]+)\slike\smac|;\sopera)/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac\sos\sx)\s?([\w\s\.]+\w)*/i,/(macintosh|mac(?=_powerpc)\s)/i],[[NAME,"Mac OS"],[VERSION,/_/g,"."]],[/((?:open)?solaris)[\/\s-]?([\w\.]+)*/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,/(unix)\s?([\w\.]+)*/i],[NAME,VERSION]]};var UAParser=function(uastring,extensions){if(typeof uastring==="object"){extensions=uastring;uastring=undefined}if(!(this instanceof UAParser)){return new UAParser(uastring,extensions).getResult()}var ua=uastring||(window&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var rgxmap=extensions?util.extend(regexes,extensions):regexes;this.getBrowser=function(){var browser={name:undefined,version:undefined};mapper.rgx.call(browser,ua,rgxmap.browser);browser.major=util.major(browser.version);return browser};this.getCPU=function(){var cpu={architecture:undefined};mapper.rgx.call(cpu,ua,rgxmap.cpu);return cpu};this.getDevice=function(){var device={vendor:undefined,model:undefined,type:undefined};mapper.rgx.call(device,ua,rgxmap.device);return device};this.getEngine=function(){var engine={name:undefined,version:undefined};mapper.rgx.call(engine,ua,rgxmap.engine);return engine};this.getOS=function(){var os={name:undefined,version:undefined};mapper.rgx.call(os,ua,rgxmap.os);return os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return ua};this.setUA=function(uastring){ua=uastring;return this};return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER={NAME:NAME,MAJOR:MAJOR,VERSION:VERSION};UAParser.CPU={ARCHITECTURE:ARCHITECTURE};UAParser.DEVICE={MODEL:MODEL,VENDOR:VENDOR,TYPE:TYPE,CONSOLE:CONSOLE,MOBILE:MOBILE,SMARTTV:SMARTTV,TABLET:TABLET,WEARABLE:WEARABLE,EMBEDDED:EMBEDDED};UAParser.ENGINE={NAME:NAME,VERSION:VERSION};UAParser.OS={NAME:NAME,VERSION:VERSION};if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if("function"===FUNC_TYPE&&__webpack_require__(6)){!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return UAParser}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(window){window.UAParser=UAParser}}var $=window&&(window.jQuery||window.Zepto);if(typeof $!==UNDEF_TYPE){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(uastring){parser.setUA(uastring);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),
/* 6 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getUaData = __webpack_require__(0);

var _types = __webpack_require__(8);

var create = _interopRequireWildcard(_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var type = create.checkType(_getUaData.device.type);

exports.default = function () {
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable;

  if (isBrowser) {
    return create.broPayload(isBrowser, _getUaData.browser, _getUaData.engine, _getUaData.os, _getUaData.ua);
  }

  if (isSmartTV) {
    return create.stvPayload(isSmartTV, _getUaData.engine, _getUaData.os, _getUaData.ua);
  }

  if (isConsole) {
    return create.consolePayload(isConsole, _getUaData.engine, _getUaData.os, _getUaData.ua);
  }

  if (isMobile) {
    return create.mobilePayload(type, _getUaData.device, _getUaData.os, _getUaData.ua);
  }

  if (isTablet) {
    return create.mobilePayload(type, _getUaData.device, _getUaData.os, _getUaData.ua);
  }

  if (isWearable) {
    return create.wearPayload(isWearable, _getUaData.engine, _getUaData.os, _getUaData.ua);
  }
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var initialData = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};

var checkType = exports.checkType = function checkType(type) {
  switch (type) {
    case "mobile":
      return {
        isMobile: true
      };
    case "tablet":
      return {
        isTablet: true
      };
    case "smarttv":
      return {
        isSmartTV: true
      };
    case "console":
      return {
        isConsole: true
      };
    case "wearable":
      return {
        isWearable: true
      };
    case undefined:
      return {
        isBrowser: true
      };
    default:
      return initialData;
  }
};

var getCurrentBrowser = exports.getCurrentBrowser = function getCurrentBrowser(name) {
  switch (name) {
    case "Chrome":
      return true;
    case "Firefox":
      return true;
    case "Opera":
      return true;
    case "Yandex":
      return true;
    case "Safari":
      return true;
    case "IE":
      return true;
    case "Edge":
      return true;
    case "Chromium":
      return true;
    default:
      return false;
  }
};

var broPayload = exports.broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: browser.major,
    browserFullVersion: browser.version,
    browserName: browser.name,
    engineName: engine.name || false,
    engineVersion: engine.version,
    osName: os.name,
    osVersion: os.version,
    userAgent: ua
  };
};

var mobilePayload = exports.mobilePayload = function mobilePayload(type, device, os, ua) {
  return _extends({}, type, {
    vendor: device.vendor || "none",
    model: device.model || "none",
    os: os.name || "none",
    osVersion: os.version || "none",
    ua: ua || "none"
  });
};

var stvPayload = exports.stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: engine.name || false,
    engineVersion: engine.version,
    osName: os.name,
    osVersion: os.version,
    userAgent: ua
  };
};

var consolePayload = exports.consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: engine.name || false,
    engineVersion: engine.version,
    osName: os.name,
    osVersion: os.version,
    userAgent: ua
  };
};

var wearPayload = exports.wearPayload = function wearPayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: engine.name || false,
    engineVersion: engine.version,
    osName: os.name,
    osVersion: os.version,
    userAgent: ua
  };
};

/***/ })
/******/ ]);

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(305);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(306);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Constants
var ID = '_grecaptcha.element.id';
var CALLBACK_NAME = '_grecaptcha.data-callback';
var EXPIRED_CALLBACK_NAME = '_grecaptcha.data-expired-callback';

var removeChild = function removeChild(elem) {
  return elem.parentNode && elem.parentNode.removeChild(elem);
};

var Recaptcha = function (_React$Component) {
  _inherits(Recaptcha, _React$Component);

  function Recaptcha() {
    _classCallCheck(this, Recaptcha);

    return _possibleConstructorReturn(this, (Recaptcha.__proto__ || Object.getPrototypeOf(Recaptcha)).apply(this, arguments));
  }

  _createClass(Recaptcha, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          locale = _props.locale,
          callback = _props.callback,
          expiredCallback = _props.expiredCallback;

      // 1. Async lazy load

      var head = document.head || document.getElementsByTagName('head')[0];
      var script = document.createElement('script');
      script.id = ID;
      script.src = 'https://www.google.com/recaptcha/api.js?hl=' + locale;
      script.type = 'text/javascript';
      script.async = true;
      script.defer = true;
      script.onerror = function (oError) {
        throw new URIError('The script ' + oError.target.src + ' is not accessible.');
      };
      head.appendChild(script);

      // 2. Expose callback function to window object
      window[CALLBACK_NAME] = callback;
      window[EXPIRED_CALLBACK_NAME] = expiredCallback;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      removeChild(document.getElementById(ID));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          sitekey = _props2.sitekey,
          invisible = _props2.invisible,
          otherProps = _objectWithoutProperties(_props2, ['className', 'sitekey', 'invisible']);

      var props = _extends({}, (0, _lodash2.default)(otherProps, ['callback', 'expiredCallback', 'locale']), {
        className: (0, _classnames2.default)('g-recaptcha', className),
        'data-sitekey': sitekey,
        'data-callback': CALLBACK_NAME,
        'data-expired-callback': EXPIRED_CALLBACK_NAME
      }, invisible && { 'data-size': 'invisible' });

      return _react2.default.createElement('div', props);
    }
  }]);

  return Recaptcha;
}(_react2.default.Component);

Recaptcha.propTypes = {
  // Required
  sitekey: _propTypes2.default.string.isRequired,
  callback: _propTypes2.default.func.isRequired,
  expiredCallback: _propTypes2.default.func.isRequired,

  // Options
  className: _propTypes2.default.string,
  invisible: _propTypes2.default.bool,
  locale: _propTypes2.default.string
};
Recaptcha.defaultProps = {
  locale: 'en',
  className: undefined,
  invisible: false
};
exports.default = Recaptcha;

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Recaptcha = __webpack_require__(303);

var _Recaptcha2 = _interopRequireDefault(_Recaptcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Recaptcha2.default;

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, props) {
  object = Object(object);
  return basePickBy(object, props, function(value, key) {
    return key in object;
  });
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick from.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, props, predicate) {
  var index = -1,
      length = props.length,
      result = {};

  while (++index < length) {
    var key = props[index],
        value = object[key];

    if (predicate(value, key)) {
      result[key] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Creates an array of the own and inherited enumerable symbol properties
 * of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable string keyed properties of `object` that are
 * not omitted.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [props] The property identifiers to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = baseRest(function(object, props) {
  if (object == null) {
    return {};
  }
  props = arrayMap(baseFlatten(props, 1), toKey);
  return basePick(object, baseDifference(getAllKeysIn(object), props));
});

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = omit;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(307)))

/***/ }),

/***/ 307:
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    bazaar_link: 'https://redirect.appmetrica.yandex.com/serve/243413381082522868?campaign=CafeBazaar',
    play_link: 'https://redirect.appmetrica.yandex.com/serve/1036046929106097450?campaign=GooglePlay',
    store_link: '/ios-tutorial',
    web_app_link: 'https://app.snapp.taxi/pre-ride?utm_source=website&utm_medium=webapp-button',
    sibapp_link: 'https://sibapp.com/applications/snapp',
    sibche_link: 'https://sibche.com/applications/snapp-3',
    sms_link: 'https://goo.gl/smvXMN',
    iApp_link: 'https://app.iapps.ir/i/191622396'
};

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(275);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDeviceDetect = __webpack_require__(302);

var _DownloadSms = __webpack_require__(311);

var _DownloadSms2 = _interopRequireDefault(_DownloadSms);

var _DownloadLinks = __webpack_require__(308);

var _DownloadLinks2 = _interopRequireDefault(_DownloadLinks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by masoud on 06/05/17.
 */
__webpack_require__(318);

var DownloadLinks = (0, _createReactClass2.default)({
  getInitialState: function getInitialState() {
    return {
      Message: null,
      isCaptcha: false
    };
  },
  getDefaultProps: function getDefaultProps() {
    return { links: _DownloadLinks2.default };
  },
  render: function render() {
    if (_reactDeviceDetect.isAndroid) {
      return _react2.default.createElement(
        "div",
        { className: "Download-Links" },
        _react2.default.createElement(
          "div",
          { className: "Apps dl-btn-responsive" },
          _react2.default.createElement(
            "a",
            {
              href: this.props.links.play_link || _DownloadLinks2.default.play_link,
              target: "_blank"
            },
            _react2.default.createElement("img", {
              src: "/assets/images/download-badges/google-play-badge.png",
              title: "\u062F\u0627\u0646\u0644\u0648\u062F \u0627\u0632 \u06AF\u0648\u06AF\u0644\u200C\u067E\u0644\u06CC",
              alt: "\u062F\u0627\u0646\u0644\u0648\u062F \u0627\u0632 \u06AF\u0648\u06AF\u0644\u200C\u067E\u0644\u06CC"
            })
          ),
          _react2.default.createElement(
            "a",
            {
              href: this.props.links.bazaar_link || _DownloadLinks2.default.bazaar_link,
              target: "_blank"
            },
            _react2.default.createElement("img", {
              src: "/assets/images/download-badges/bazaar.png",
              title: "\u062F\u0627\u0646\u0644\u0648\u062F \u0627\u0632 \u0628\u0627\u0632\u0627\u0631",
              alt: "\u062F\u0627\u0646\u0644\u0648\u062F \u0627\u0632 \u0628\u0627\u0632\u0627\u0631"
            })
          )
        ),
        _react2.default.createElement(
          "h6",
          null,
          "\u06CC\u0627"
        ),
        _react2.default.createElement(_DownloadSms2.default, null),
        _react2.default.createElement(
          "div",
          { className: "Apps dl-btn-responsive" },
          _react2.default.createElement(
            "p",
            null,
            "\u0647\u0645\u0686\u0646\u06CC\u0646 \u0642\u0627\u0628\u0644 \u062F\u0633\u062A\u0631\u0633 \u0627\u0632 \u0637\u0631\u06CC\u0642"
          ),
          _react2.default.createElement(
            "a",
            {
              href: this.props.links.web_app_link || _DownloadLinks2.default.web_app_link,
              target: "_blank"
            },
            _react2.default.createElement("img", {
              src: "/assets/images/download-badges/snapp_pwa.png",
              title: "\u0646\u0633\u062E\u0647 \u062A\u062D\u062A \u0648\u0628 \u0627\u0633\u0646\u067E",
              alt: "\u0646\u0633\u062E\u0647 \u062A\u062D\u062A \u0648\u0628 \u0627\u0633\u0646\u067E"
            })
          )
        )
      );
    }

    if (_reactDeviceDetect.isIOS) {
      return _react2.default.createElement(
        "div",
        { className: "Download-Links" },
        _react2.default.createElement(
          "div",
          { className: "Apps dl-btn-responsive" },
          _react2.default.createElement(
            "div",
            { className: "download-link-title" },
            "\u062F\u0633\u062A\u0631\u0633\u06CC \u0628\u0647 \u0648\u0628 \u0627\u067E\u0644\u06CC\u06A9\u06CC\u0634\u0646 \u0646\u0633\u062E\u0647 \u0645\u0627\u0646\u062F\u06AF\u0627\u0631 \u0627\u0633\u0646\u067E"
          ),
          _react2.default.createElement(
            "a",
            {
              href: this.props.links.web_app_link || _DownloadLinks2.default.web_app_link,
              target: "_blank"
            },
            _react2.default.createElement("img", {
              src: "/assets/images/download-badges/snapp_pwa.png",
              title: "\u0646\u0633\u062E\u0647 \u062A\u062D\u062A \u0648\u0628 \u0627\u0633\u0646\u067E",
              alt: "\u0646\u0633\u062E\u0647 \u062A\u062D\u062A \u0648\u0628 \u0627\u0633\u0646\u067E"
            })
          ),
          _react2.default.createElement(
            "a",
            {
              href: this.props.links.sibapp_link || _DownloadLinks2.default.sibapp_link,
              target: "_blank"
            },
            _react2.default.createElement("img", {
              src: "/assets/images/download-badges/sibapp-badge-white.png",
              title: "\u062F\u0627\u0646\u0644\u0648\u062F \u0646\u0633\u062E\u0647 iOS \u0627\u0632 \u0633\u06CC\u0628 \u0627\u067E",
              alt: "\u062F\u0627\u0646\u0644\u0648\u062F \u0646\u0633\u062E\u0647 iOS \u0627\u0632 \u0633\u06CC\u0628 \u0627\u067E"
            })
          ),
          _react2.default.createElement(
            "a",
            {
              href: this.props.links.iApp_link || _DownloadLinks2.default.iApp_link,
              target: "_blank"
            },
            _react2.default.createElement("img", {
              src: "/assets/images/download-badges/iApps.png",
              title: "\u0646\u0633\u062E\u0647 \u062A\u062D\u062A \u0622\u06CC\u200C\u0627\u067E\u0633 \u0627\u0633\u0646\u067E",
              alt: "\u0646\u0633\u062E\u0647 \u0622\u06CC\u200C\u0627\u067E\u0633 \u0627\u0633\u0646\u067E"
            })
          ),
          _react2.default.createElement(
            "a",
            {
              href: this.props.links.sibche_link || _DownloadLinks2.default.sibche_link,
              target: "_blank"
            },
            _react2.default.createElement("img", {
              src: "/assets/images/download-badges/sibche.png",
              title: "\u062F\u0627\u0646\u0644\u0648\u062F \u0646\u0633\u062E\u0647 iOS \u0627\u0632 \u0633\u06CC\u0628\u0686\u0647",
              alt: "\u062F\u0627\u0646\u0644\u0648\u062F \u0646\u0633\u062E\u0647 iOS \u0627\u0632 \u0633\u06CC\u0628\u0686\u0647"
            })
          )
        ),
        _react2.default.createElement(
          "h6",
          null,
          "\u06CC\u0627 "
        ),
        _react2.default.createElement(_DownloadSms2.default, null)
      );
    }

    return _react2.default.createElement(
      "div",
      { className: "Download-Links" },
      _react2.default.createElement(_DownloadSms2.default, null),
      _react2.default.createElement(
        "h6",
        null,
        "\u06CC\u0627"
      ),
      _react2.default.createElement(
        "div",
        { className: "Apps" },
        _react2.default.createElement(
          "div",
          { className: "androidLinks dl-links-wrapper" },
          _react2.default.createElement(
            "a",
            {
              href: this.props.links.play_link || _DownloadLinks2.default.play_link,
              target: "_blank"
            },
            _react2.default.createElement("img", {
              src: "/assets/images/download-badges/google-play-badge.png",
              title: "\u062F\u0627\u0646\u0644\u0648\u062F \u0627\u0632 \u06AF\u0648\u06AF\u0644\u200C\u067E\u0644\u06CC",
              alt: "\u062F\u0627\u0646\u0644\u0648\u062F \u0627\u0632 \u06AF\u0648\u06AF\u0644\u200C\u067E\u0644\u06CC"
            })
          ),
          _react2.default.createElement(
            "a",
            {
              href: this.props.links.bazaar_link || _DownloadLinks2.default.bazaar_link,
              target: "_blank"
            },
            _react2.default.createElement("img", {
              src: "/assets/images/download-badges/bazaar.png",
              title: "\u062F\u0627\u0646\u0644\u0648\u062F \u0627\u0632 \u0628\u0627\u0632\u0627\u0631",
              alt: "\u062F\u0627\u0646\u0644\u0648\u062F \u0627\u0632 \u0628\u0627\u0632\u0627\u0631"
            })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "iosLinks dl-links-wrapper" },
          _react2.default.createElement(
            "a",
            {
              href: this.props.links.web_app_link || _DownloadLinks2.default.web_app_link,
              target: "_blank"
            },
            _react2.default.createElement("img", {
              src: "/assets/images/download-badges/snapp_pwa.png",
              title: "\u0646\u0633\u062E\u0647 \u062A\u062D\u062A \u0648\u0628 \u0627\u0633\u0646\u067E",
              alt: "\u0646\u0633\u062E\u0647 \u062A\u062D\u062A \u0648\u0628 \u0627\u0633\u0646\u067E"
            })
          ),
          _react2.default.createElement(
            "a",
            {
              href: this.props.links.sibapp_link || _DownloadLinks2.default.sibapp_link,
              target: "_blank"
            },
            _react2.default.createElement("img", {
              src: "/assets/images/download-badges/sibapp-badge-white.png",
              title: "\u062F\u0627\u0646\u0644\u0648\u062F \u0646\u0633\u062E\u0647 iOS \u0627\u0632 \u0633\u06CC\u0628 \u0627\u067E",
              alt: "\u062F\u0627\u0646\u0644\u0648\u062F \u0646\u0633\u062E\u0647 iOS \u0627\u0632 \u0633\u06CC\u0628 \u0627\u067E"
            })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "iosLinks dl-links-wrapper" },
          _react2.default.createElement(
            "a",
            {
              href: this.props.links.iApp_link || _DownloadLinks2.default.iApp_link,
              target: "_blank"
            },
            _react2.default.createElement("img", {
              src: "/assets/images/download-badges/iApps.png",
              title: "\u0646\u0633\u062E\u0647 \u062A\u062D\u062A \u0622\u06CC\u200C\u0627\u067E\u0633 \u0627\u0633\u0646\u067E",
              alt: "\u0646\u0633\u062E\u0647 \u0622\u06CC\u200C\u0627\u067E\u0633 \u0627\u0633\u0646\u067E"
            })
          ),
          _react2.default.createElement(
            "a",
            {
              href: this.props.links.sibche_link || _DownloadLinks2.default.sibche_link,
              target: "_blank"
            },
            _react2.default.createElement("img", {
              src: "/assets/images/download-badges/sibche.png",
              title: "\u062F\u0627\u0646\u0644\u0648\u062F \u0646\u0633\u062E\u0647 iOS \u0627\u0632 \u0633\u06CC\u0628\u0686\u0647",
              alt: "\u062F\u0627\u0646\u0644\u0648\u062F \u0646\u0633\u062E\u0647 iOS \u0627\u0632 \u0633\u06CC\u0628\u0686\u0647"
            })
          )
        )
      )
    );
  }
});

DownloadLinks.propTypes = {
  links: _propTypes2.default.any
};

module.exports = DownloadLinks;

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(275);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _reactGrecaptcha = __webpack_require__(304);

var _reactGrecaptcha2 = _interopRequireDefault(_reactGrecaptcha);

var _reactDeviceDetect = __webpack_require__(302);

var _ServerCalls = __webpack_require__(285);

var _NumberConvertor = __webpack_require__(298);

var _DownloadLinks = __webpack_require__(308);

var _DownloadLinks2 = _interopRequireDefault(_DownloadLinks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DownloadSms = (0, _createReactClass2.default)({
  getInitialState: function getInitialState() {
    return {
      Message: null,
      isCaptcha: false,
      phoneValue: ""
    };
  },
  render: function render() {
    return _react2.default.createElement(
      "div",
      { className: "Download-Sms" },
      _react2.default.createElement(
        "p",
        null,
        "\u0628\u0631\u0627\u06CC \u062F\u0631\u06CC\u0627\u0641\u062A \u0644\u06CC\u0646\u06A9 \u062F\u0627\u0646\u0644\u0648\u062F\u060C \u0634\u0645\u0627\u0631\u0647 \u062E\u0648\u062F \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F."
      ),
      _react2.default.createElement(
        "div",
        { className: "Fields" },
        _react2.default.createElement(
          "form",
          null,
          _react2.default.createElement(
            "div",
            { className: "Row" },
            _react2.default.createElement("input", {
              type: "tel",
              className: "Phone Phone-Small",
              ref: "phone",
              pattern: "^[0-9,\u06F0-\u06F9]{11}$",
              placeholder: " \u0634\u0645\u0627\u0631\u0647 \u0645\u0648\u0628\u0627\u06CC\u0644",
              onChange: this.handleChange
            }),
            _react2.default.createElement(
              "div",
              {
                className: "Send-Button" + (_reactDeviceDetect.isMobile ? " Send-Button-Small" : ""),
                onClick: this.sendSms
              },
              "\u0627\u0631\u0633\u0627\u0644 \u0644\u06CC\u0646\u06A9 \u062F\u0627\u0646\u0644\u0648\u062F"
            )
          ),
          this.state.isCaptcha && _react2.default.createElement(_reactGrecaptcha2.default, {
            sitekey: "6LcyGbAUAAAAALbRYcIRrCBF-Y9V9EsoIUfnNXBL",
            callback: this.captchaVerified,
            locale: "fa",
            expiredCallback: this.captchaExpired
          })
        ),
        this.state.Message && _react2.default.createElement(
          "div",
          { className: "Message", style: { color: this.state.messageColor } },
          this.state.Message
        )
      )
    );
  },
  captchaVerified: function captchaVerified(e) {
    this.setState({
      isCaptcha: false,
      captcha: e
    });
    this.sendSms();
  },
  handleChange: function handleChange(e) {
    this.setState({
      phoneValue: e.target.value
    });
  },
  sendSms: function sendSms() {
    var phoneValue = this.state.phoneValue;

    if (!this.refs.phone || !this.refs.phone.checkValidity()) {
      this.setState({
        Message: "لطفا شماره خود را به درستی وارد کنید",
        messageColor: "red",
        phoneValue: ""
      });
      setTimeout(this.setState.bind(this, { message: null }), 3000);
      return;
    }
    var phone = (0, _NumberConvertor.deLocalize)(this.refs.phone.value.trim());
    var data = { phone: phone };
    if (this.state.captcha) {
      data["g-recaptcha-response"] = this.state.captcha;
    }
    if (this.props.links) {
      data.link = this.props.links.sms_link;
    }
    this.setState({
      Message: "در حال ارسال درخواست...",
      messageColor: "#fff"
    });
    (0, _ServerCalls.sendSms)(data, this.smsSent);
  },
  captchaExpired: function captchaExpired() {
    this.setState({
      Message: ".زمان پاسخگویی شما به پایان رسیده است",
      messageColor: "#f93030",
      captcha: null
    });
  },
  smsSent: function smsSent(data) {
    var statesData = {};

    switch (data.status) {
      case 200:
        statesData = {
          Message: "\u0644\u06CC\u0646\u06A9 \u200C\u0647\u0627\u06CC \u062F\u0627\u0646\u0644\u0648\u062F \u0628\u0627 \u0645\u0648\u0641\u0642\u06CC\u062A \u0628\u0647 \u0634\u0645\u0627\u0631\u0647 " + this.state.phoneValue + " \u0627\u0631\u0633\u0627\u0644 \u0634\u062F",
          messageColor: "#3cb567"
        };
        this.refs.phone.value = "";

        break;

      case 429:
        statesData = { isCaptcha: true };
        setTimeout(this.setState.bind(this, { Message: null, captcha: null }), 1000);

        break;

      case 400:
        statesData = {
          Message: ".لطفا شماره خود را به درستی وارد کنید",
          messageColor: "#f93030"
        };

        break;

      case 405:
        statesData = {
          Message: ".تعداد مجاز ارسال پیام برای شما به پایان رسیده است",
          messageColor: "#f93030"
        };
        break;

      default:
        statesData = {
          Message: ".مشکلی در فرآیند ارسال وجود داشت، لطفا بعدا تلاش کنید",
          messageColor: "#f93030"
        };
        break;
    }

    this.setState(statesData);

    setTimeout(this.setState.bind(this, { Message: null, captcha: null }), 3000);
  }
});

exports.default = DownloadSms;

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(111)();
// imports


// module
exports.push([module.i, ".d-none {\n  display: none;\n}\n#CenterElement {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n}\n#Button {\n  background-color: #00d170;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);\n  position: relative;\n  display: -webkit-inline-box;\n  display: -webkit-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  padding: 7px 15px;\n  min-height: 30px;\n  min-width: 4rem;\n  overflow: hidden;\n  line-height: 2;\n  text-align: center;\n  font-weight: 800;\n  border: 0;\n  border-radius: 2rem;\n  vertical-align: middle;\n  white-space: nowrap;\n  cursor: pointer;\n  -ms-touch-action: manipulation;\n      touch-action: manipulation;\n  -webkit-transition: all ease-in-out 0.175s;\n  transition: all ease-in-out 0.175s;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  color: #eee;\n  text-decoration: none;\n  -webkit-transition: all 450ms ease-in-out;\n  transition: all 450ms ease-in-out;\n}\n#Button i {\n  line-height: 35px;\n  text-align: center;\n  vertical-align: middle;\n}\n#Button:hover,\n#Button:active,\n#Button:focus {\n  background-color: #03d873;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15), 0 1px 4px rgba(0, 0, 0, 0.1);\n}\n#Button i {\n  margin-left: 0;\n}\n#BrightHover {\n  -webkit-transition: all 450ms ease-in-out;\n  transition: all 450ms ease-in-out;\n}\n#BrightHover:hover {\n  opacity: 0.6;\n}\n@-webkit-keyframes fade-in {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 0.6;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes fade-in {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 0.6;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.Download-Links .Download-Sms p {\n  margin-top: 20px;\n  line-height: 38px;\n  color: white;\n  font-size: 18px;\n  font-weight: bold;\n  text-align: center;\n  text-shadow: -1px 1px 2px black;\n}\n.Download-Links .Download-Sms .Fields {\n  margin: auto;\n  max-width: 450px;\n  margin-top: 40px;\n  width: 90%;\n}\n.Download-Links .Download-Sms .Fields form {\n  width: 100%;\n}\n.Download-Links .Download-Sms .Fields form .Row {\n  width: 100%;\n  display: -webkit-inline-box;\n  display: -webkit-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n.Download-Links .Download-Sms .Fields form .Row .Phone {\n  height: 70px;\n  outline: none;\n  font-size: 18px;\n  line-height: 2;\n  width: 70%;\n  padding: 10px;\n  background-color: #fff;\n  vertical-align: middle;\n  direction: rtl;\n  resize: none;\n  -webkit-transition: all 450ms ease-in-out;\n  transition: all 450ms ease-in-out;\n  border-radius: 0%;\n  border: 1px solid #dbdbdb;\n}\n.Download-Links .Download-Sms .Fields form .Row .Phone-Small {\n  padding: 5px;\n  box-sizing: border-box;\n}\n.Download-Links .Download-Sms .Fields form .Row .Send-Button {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);\n  position: relative;\n  display: -webkit-inline-box;\n  display: -webkit-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  padding: 7px 15px;\n  min-height: 30px;\n  min-width: 4rem;\n  overflow: hidden;\n  line-height: 2;\n  text-align: center;\n  font-weight: 800;\n  border: 0;\n  border-radius: 2rem;\n  cursor: pointer;\n  -ms-touch-action: manipulation;\n      touch-action: manipulation;\n  -webkit-transition: all ease-in-out 0.175s;\n  transition: all ease-in-out 0.175s;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  text-decoration: none;\n  -webkit-transition: all 450ms ease-in-out;\n  transition: all 450ms ease-in-out;\n  padding: 15px 30px;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 38px;\n  vertical-align: middle;\n  white-space: nowrap;\n  border-radius: 0;\n  background-color: #00d170;\n  color: #eee;\n  border: none;\n}\n.Download-Links .Download-Sms .Fields form .Row .Send-Button i {\n  line-height: 35px;\n  text-align: center;\n  vertical-align: middle;\n}\n.Download-Links .Download-Sms .Fields form .Row .Send-Button:hover,\n.Download-Links .Download-Sms .Fields form .Row .Send-Button:active,\n.Download-Links .Download-Sms .Fields form .Row .Send-Button:focus {\n  background-color: #03d873;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15), 0 1px 4px rgba(0, 0, 0, 0.1);\n}\n.Download-Links .Download-Sms .Fields form .Row .Send-Button i {\n  margin-left: 0;\n}\n.Download-Links .Download-Sms .Fields form .Row .Send-Button-Small {\n  font-size: 10px;\n  background-color: #00d170;\n  color: #eee;\n  border-radius: 0%;\n}\n.Download-Links .Download-Sms .Fields .g-recaptcha {\n  margin: 20px auto auto;\n}\n.Download-Links .Download-Sms .Fields .g-recaptcha > div {\n  margin: auto;\n}\n.Download-Links .Download-Sms .Fields .Message {\n  color: #00ef74;\n  font-size: 18px;\n  width: 100%;\n  margin-top: 20px;\n  text-align: center;\n}\n.Download-Links h6 {\n  margin-top: 20px;\n  line-height: 38px;\n  color: white;\n  font-size: 25px;\n  font-weight: bold;\n  text-align: center;\n  text-shadow: 0px 1px 2px black;\n}\n.Download-Links .Apps {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  margin: 30px auto 0 auto;\n  width: 463px;\n}\n.Download-Links .Apps p {\n  margin-bottom: 15px;\n}\n.Download-Links .Apps img {\n  width: 220px;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n.Download-Links .Apps img:hover {\n  -webkit-filter: brightness(110%);\n          filter: brightness(110%);\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n.Download-Links .Apps .sibAppbtn {\n  width: 225px;\n}\n.Download-Links .Apps .dl-links-wrapper {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.Download-Links .Apps .dl-links-wrapper a {\n  margin: 3px 5px;\n}\n.Download-Links .Apps .sibche-app-btn-wrapper {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n.Download-Links .IOS-Help {\n  margin: 30px auto;\n  width: 400px;\n}\n.Download-Links .IOS-Help p {\n  text-align: right;\n  margin-top: 20px;\n  line-height: 28px;\n  color: white;\n  font-size: 18px;\n  text-shadow: -1px 1px 1px black;\n  font-weight: 500;\n}\n.Download-Links .IOS-Help p a {\n  color: #00ef74;\n}\n.download-link-title {\n  color: #d8d8d8;\n  padding: 0 32px;\n  margin-bottom: 25px;\n  font-weight: bold;\n  text-shadow: -1px 1px 1px black;\n  font-size: 18px;\n  line-height: 29px;\n}\n@media screen and (max-width: 600px) {\n  .dl-btn-responsive {\n    margin-top: 10px;\n  }\n  .dl-btn-responsive a {\n    margin: 3px 0;\n  }\n  .dl-btn-responsive img {\n    width: 170px !important;\n  }\n  .Download-Links .Apps {\n    width: auto;\n  }\n}\n", ""]);

// exports


/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(312);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(112)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?url=false!../../node_modules/autoprefixer-loader/index.js?browsers=last 9 versions!../../node_modules/postcss-loader/index.js!../../node_modules/less-loader/index.js!./DownloadLinks.less", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?url=false!../../node_modules/autoprefixer-loader/index.js?browsers=last 9 versions!../../node_modules/postcss-loader/index.js!../../node_modules/less-loader/index.js!./DownloadLinks.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(275);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDeviceDetect = __webpack_require__(302);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by masoud on 06/05/17.
 */
var DownloadLinks = __webpack_require__(310);
__webpack_require__(357);
var DownloadSection = (0, _createReactClass2.default)({
  displayName: "DownloadSection",
  getDefaultProps: function getDefaultProps() {
    return {
      sms_link: null
    };
  },
  render: function render() {
    return _react2.default.createElement(
      "div",
      { className: "Download-Section" },
      _react2.default.createElement(
        "div",
        { className: "Texts" + (_reactDeviceDetect.isMobile ? " Texts-Small" : "") },
        _react2.default.createElement(
          "h2",
          null,
          "\u062F\u0627\u0646\u0644\u0648\u062F \u0628\u0631\u0646\u0627\u0645\u0647 ",
          _react2.default.createElement(
            "span",
            { className: "snapp" },
            "\u0627\u0633\u0646\u067E"
          ),
          " \u0645\u0633\u0627\u0641\u0631\u0627\u0646"
        ),
        _react2.default.createElement(DownloadLinks, null)
      )
    );
  }
});

DownloadSection.propTypes = {
  sms_link: _propTypes2.default.string
};

module.exports = DownloadSection;

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(111)();
// imports


// module
exports.push([module.i, ".d-none {\n  display: none;\n}\n#CenterElement {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n}\n#Button {\n  background-color: #00d170;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);\n  position: relative;\n  display: -webkit-inline-box;\n  display: -webkit-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  padding: 7px 15px;\n  min-height: 30px;\n  min-width: 4rem;\n  overflow: hidden;\n  line-height: 2;\n  text-align: center;\n  font-weight: 800;\n  border: 0;\n  border-radius: 2rem;\n  vertical-align: middle;\n  white-space: nowrap;\n  cursor: pointer;\n  -ms-touch-action: manipulation;\n      touch-action: manipulation;\n  -webkit-transition: all ease-in-out 0.175s;\n  transition: all ease-in-out 0.175s;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  color: #eee;\n  text-decoration: none;\n  -webkit-transition: all 450ms ease-in-out;\n  transition: all 450ms ease-in-out;\n}\n#Button i {\n  line-height: 35px;\n  text-align: center;\n  vertical-align: middle;\n}\n#Button:hover,\n#Button:active,\n#Button:focus {\n  background-color: #03d873;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15), 0 1px 4px rgba(0, 0, 0, 0.1);\n}\n#Button i {\n  margin-left: 0;\n}\n#BrightHover {\n  -webkit-transition: all 450ms ease-in-out;\n  transition: all 450ms ease-in-out;\n}\n#BrightHover:hover {\n  opacity: 0.6;\n}\n@-webkit-keyframes fade-in {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 0.6;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes fade-in {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 0.6;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.Download-Section {\n  width: -webkit-calc(100% - 2 * 16%);\n  width: calc(100% - 2 * 16%);\n  position: relative;\n  direction: rtl;\n  padding: 32px 16%;\n  background: url(../../assets/images/main-bg.jpg) no-repeat center;\n  background-size: cover;\n  display: -webkit-inline-box;\n  display: -webkit-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n.Download-Section .snapp {\n  color: #00d170;\n}\n.Download-Section .Divider {\n  height: 20vh;\n}\n.Download-Section .Texts {\n  width: 100%;\n  direction: rtl;\n  text-align: center;\n}\n.Download-Section .Texts h2 {\n  color: white;\n  font-size: 40px;\n  text-shadow: -1px 1px 5px black;\n  text-align: center;\n}\n.Download-Section .Texts h5 {\n  color: black;\n  font-size: 25px;\n  margin-top: 20px;\n  line-height: 28px;\n}\n.Download-Section .Texts p {\n  font-size: 18px;\n  margin-top: 20px;\n  line-height: 28px;\n  color: white;\n}\n.Download-Section .Texts-Small h2 {\n  font-size: 25px;\n}\n.Download-Section .App-Image {\n  width: -webkit-calc(100% - -webkit-calc(70% - 20px));\n  width: calc(100% - calc(70% - 20px));\n  text-align: center;\n}\n.Download-Section .App-Image img {\n  width: 90%;\n}\n", ""]);

// exports


/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(350);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(112)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?url=false!../../node_modules/autoprefixer-loader/index.js?browsers=last 9 versions!../../node_modules/postcss-loader/index.js!../../node_modules/less-loader/index.js!./DownloadSection.less", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?url=false!../../node_modules/autoprefixer-loader/index.js?browsers=last 9 versions!../../node_modules/postcss-loader/index.js!../../node_modules/less-loader/index.js!./DownloadSection.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(275);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(566); /**
                                                    * Created by masoud on 05/05/17.
                                                    */

var SnappFeatures = (0, _createReactClass2.default)({
    getInitialState: function getInitialState() {
        return {
            currentTab: 0,
            pages: this.props.pages
        };
    },
    getDefaultProps: function getDefaultProps() {
        return {
            pages: []
        };
    },
    render: function render() {
        var self = this;
        var page = this.state.pages[this.state.currentTab];
        return _react2.default.createElement(
            "div",
            { className: "Snapp-Features" },
            _react2.default.createElement(
                "h2",
                { className: "F-Header" },
                "\u0648\u06CC\u0698\u06AF\u06CC\u200C\u0647\u0627\u06CC \u0627\u0633\u0646\u067E"
            ),
            _react2.default.createElement(
                "div",
                { className: "Wrapper" },
                _react2.default.createElement(
                    "div",
                    { className: "Snapp-Features-Inner" },
                    _react2.default.createElement(
                        "div",
                        { className: "Tabs" },
                        this.props.pages.map(function (item, index) {
                            return _react2.default.createElement(
                                "div",
                                { className: "Tab" + (self.state.currentTab === index ? " active" : ""),
                                    onClick: self.changePage.bind(self, index),
                                    key: index },
                                _react2.default.createElement("i", { className: item.tab.icon }),
                                _react2.default.createElement("br", null),
                                item.tab.text
                            );
                        })
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "Pages" },
                        _react2.default.createElement("div", { className: "Image", style: { backgroundPosition: "0 " + page.content.image + "px" } }),
                        _react2.default.createElement(
                            "div",
                            { className: "Text" },
                            _react2.default.createElement(
                                "h2",
                                null,
                                page.content.header
                            ),
                            _react2.default.createElement(
                                "p",
                                { className: "Sub-Header" },
                                page.content.subHeader
                            ),
                            _react2.default.createElement("p", { className: "F-Text", dangerouslySetInnerHTML: { __html: page.content.text.replace(/\n/g, '<br/>') } })
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "Dots" },
                            this.state.pages.map(function (item, index) {
                                return _react2.default.createElement("div", { className: "Dot" + (index === self.state.currentTab ? " D-active" : ""),
                                    key: index, onClick: self.changePage.bind(self, index) });
                            })
                        )
                    )
                )
            )
        );
    },
    changePage: function changePage(index) {
        this.setState({
            currentTab: index
        });
    }
});

SnappFeatures.propTypes = {
    pages: _propTypes2.default.array
};

module.exports = SnappFeatures;

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(275);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import DownloadButton from "../../common/DownloadButton.react";

/**
 * Created by masoud on 05/05/17.
 */
var SnappIntro = (0, _createReactClass2.default)({
  render: function render() {
    return _react2.default.createElement(
      "div",
      { className: "Snapp-Intro" },
      _react2.default.createElement(
        "div",
        { className: "Introduction" },
        _react2.default.createElement(
          "h1",
          null,
          "\u062A\u0627\u06A9\u0633\u06CC \u0627\u06CC\u0646\u062A\u0631\u0646\u062A\u06CC \u0627\u0633\u0646\u067E \u0631\u0627 \u0628\u0634\u0646\u0627\u0633\u06CC\u062F"
        ),
        _react2.default.createElement(
          "p",
          null,
          "\u0627\u0633\u0646\u067E\u060C \u0627\u0648\u0644\u06CC\u0646 \u0648 \u0628\u0632\u0631\u06AF\u200C\u062A\u0631\u06CC\u0646 \u062A\u0627\u06A9\u0633\u06CC \u0627\u06CC\u0646\u062A\u0631\u0646\u062A\u06CC \u0627\u06CC\u0631\u0627\u0646\u060C \u067E\u0644 \u0627\u0631\u062A\u0628\u0627\u0637\u06CC \u0645\u06CC\u0627\u0646 \u06A9\u0627\u0631\u0628\u0631 \u0645\u0633\u0627\u0641\u0631 \u0648 \u06A9\u0627\u0631\u0628\u0631 \u0631\u0627\u0646\u0646\u062F\u0647 \u0627\u0633\u062A \u0648 \u0631\u0627\u0647\u06A9\u0627\u0631\u06CC \u0633\u0631\u06CC\u0639 \u0648 \u0633\u0627\u062F\u0647 \u0628\u0631\u0627\u06CC \u062F\u0631\u062E\u0648\u0627\u0633\u062A \u062E\u0648\u062F\u0631\u0648 \u0648 \u0645\u0648\u062A\u0648\u0631\u0633\u06CC\u06A9\u0644\u062A \u0628\u0647 \u0634\u0645\u0627\u0631 \u0645\u06CC\u200C\u0631\u0648\u062F. \u0628\u0627 \u062F\u0631\u062E\u0648\u0627\u0633\u062A \u062E\u0648\u062F\u0631\u0648 \u06CC\u0627 \u0645\u0648\u062A\u0648\u0631\u0633\u06CC\u06A9\u0644\u062A \u062F\u0631 \u0627\u06CC\u0646 \u0627\u067E\u0644\u06CC\u06A9\u06CC\u0634\u0646\u060C \u067E\u0633 \u0627\u0632 \u0645\u0634\u062E\u0635 \u06A9\u0631\u062F\u0646 \u0645\u0628\u062F\u0627 \u0648 \u0645\u0642\u0635\u062F\u060C \u0646\u0632\u062F\u06CC\u06A9\u200C\u062A\u0631\u06CC\u0646 \u0627\u0633\u0646\u067E \u0628\u0647 \u0646\u0634\u0627\u0646\u06CC \u0634\u0645\u0627 \u0645\u06CC\u200C\u0622\u06CC\u062F. \u0628\u0627 \u0627\u0633\u0646\u067E \u0633\u0641\u0631\u06CC \u0627\u06CC\u0645\u0646\u060C \u0631\u0627\u062D\u062A \u0648 \u0645\u0642\u0631\u0648\u0646\u200C\u0628\u0647\u200C\u0635\u0631\u0641\u0647 \u0631\u0627 \u062A\u062C\u0631\u0628\u0647 \u062E\u0648\u0627\u0647\u06CC\u062F \u06A9\u0631\u062F."
        )
      )
    );
  }
});

module.exports = SnappIntro;

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(275);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _Testimonial = __webpack_require__(494);

var _Testimonial2 = _interopRequireDefault(_Testimonial);

var _SnappServicesContent = __webpack_require__(515);

var _SnappServicesContent2 = _interopRequireDefault(_SnappServicesContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(567);
var SnappServicesSection = (0, _createReactClass2.default)({
  render: function render() {
    return _react2.default.createElement(
      "div",
      { className: "root" },
      _react2.default.createElement(
        "div",
        { className: "header-container" },
        _react2.default.createElement(
          "h1",
          { className: "header" },
          " \u0622\u0634\u0646\u0627\u06CC\u06CC \u0628\u0627 \u0633\u0631\u0648\u06CC\u0633\u200C\u0647\u0627\u06CC \u0627\u0633\u0646\u067E!"
        )
      ),
      _react2.default.createElement(
        "p",
        { className: "snapp-description" },
        "\u0633\u0648\u067E\u0631\u0627\u067E\u0644\u06CC\u06A9\u06CC\u0634\u0646 \u0627\u0633\u0646\u067E!\u060C \u0628\u0627 \u0627\u0631\u0627\u0626\u0647 \u0631\u0627\u0647\u06A9\u0627\u0631\u0647\u0627\u06CC \u062C\u062F\u06CC\u062F \u0628\u0631\u0627\u06CC \u0646\u06CC\u0627\u0632\u0647\u0627\u06CC \u0645\u062E\u062A\u0644\u0641\u060C \u0632\u0646\u062F\u06AF\u06CC \u0634\u0645\u0627 \u0631\u0627 \u0647\u0648\u0634\u0645\u0646\u062F \u0645\u06CC\u200C\u06A9\u0646\u062F. \u0633\u0627\u062F\u06AF\u06CC\u060C \u0633\u0631\u0639\u062A \u0648 \u0645\u0642\u0631\u0648\u0646 \u0628\u0647 \u0635\u0631\u0641\u0647 \u0628\u0648\u062F\u0646 \u0634\u0639\u0627\u0631 \u0627\u0633\u0646\u067E \u0627\u0633\u062A \u0648 \u062F\u0631 \u062A\u0645\u0627\u0645 \u0633\u0631\u0648\u06CC\u0633\u200C\u0647\u0627\u06CC \u0627\u06CC\u0646 \u0645\u062C\u0645\u0648\u0639\u0647 \u0628\u0647 \u0639\u0646\u0648\u0627\u0646 \u0627\u0648\u0644\u0648\u06CC\u062A\u200C\u0647\u0627\u06CC \u0627\u0635\u0644\u06CC \u0634\u0646\u0627\u062E\u062A\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F."
      ),
      _react2.default.createElement(
        "div",
        { className: "snapp-services-container" },
        _SnappServicesContent2.default.map(function (item) {
          return _react2.default.createElement(_Testimonial2.default, {
            testimonialImage: item.img,
            testimonialTitle: item.title,
            titleIntro: item.titleIntro,
            testimonialDescription: item.desc,
            link: item.link,
            linkAble: item.linkAble

          });
        })
      )
    );
  }
});

module.exports = SnappServicesSection;

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(569);
var Testimonial = function Testimonial(props) {
  var testimonialImage = props.testimonialImage,
      testimonialTitle = props.testimonialTitle,
      testimonialDescription = props.testimonialDescription,
      titleIntro = props.titleIntro,
      linkAble = props.linkAble,
      link = props.link;

  return _react2.default.createElement(
    'div',
    { className: 'testimonial-container' },
    _react2.default.createElement(
      'div',
      { className: 'image-border' },
      _react2.default.createElement('img', { src: testimonialImage, className: 'testimonial-image', alt: 'testimonialImage' })
    ),
    _react2.default.createElement(
      'h3',
      { className: 'testimonial-title' },
      testimonialTitle
    ),
    linkAble ? _react2.default.createElement(
      'a',
      { className: 'title-tip', href: link },
      titleIntro
    ) : _react2.default.createElement(
      'p',
      { className: 'title-tip' },
      titleIntro
    ),
    _react2.default.createElement(
      'p',
      { className: 'testimonial-description' },
      testimonialDescription
    )
  );
};

Testimonial.propTypes = {
  testimonialImage: _propTypes2.default.string.isRequired,
  testimonialTitle: _propTypes2.default.string.isRequired,
  testimonialDescription: _propTypes2.default.string.isRequired,
  titleIntro: _propTypes2.default.string.isRequired,
  linkAble: _propTypes2.default.bool,
  link: _propTypes2.default.string
};
// Testimonial.defaultProps = {
//   linkAble: false,
//   link="/"
// }
module.exports = Testimonial;

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by masoud on 05/05/17.
 */
module.exports = [{
    tab: {
        icon: 'icon-star',
        text: 'امنیت‌ و‌آسایش'
    },
    content: {
        image: -796,
        header: 'امنیت در اولویت است',
        subHeader: 'امنیت کاربران اولویت اصلی اسنپ است. به همین منظور تلاش می‌کنیم قابلیت‌هایی در جهت امنیت و آسایش بیشتر سفرهای خود به وجود آوریم. قابلیت‌هایی مانند:',
        text: '<ul><li>' + 'تایید صلاحیت کاربران راننده توسط ناجا' + '</li>' + '<li>' + 'ثبت اطلاعات کاربر راننده در تاکسی اینترنتی' + '</li>' + '<li>' + 'بررسی خودرو کاربر راننده' + '</li>' + '<li>' + 'عکس کاربر راننده' + '</li>' + '<li>' + 'امکان به اشتراک گذاشتن اطلاعات و نقشه مسیر با آشنایان' + '</li>' + '<li>' + 'پنهان‌سازی شماره تلفن کاربران راننده و مسافر در حین تماس' + '</li>'
    }
}, {
    tab: {
        icon: 'icon-clock',
        text: 'ویژگی‌‌ها و قابلیت‌ها'
    },
    content: {
        image: -996,
        header: 'با تاکسی اینترنتی اسنپ، هوشمند سفر کنید',
        subHeader: 'ویژگی‌های اسنپ همه آن چیزی است که یک شهروند هوشمند به آن نیاز دارد. قابلیت‌هایی مانند:',
        text: '<li>' + 'صرفه‌جویی در هزینه و زمان' + '</li>' + '<li>' + 'حق انتخاب در نحوه پرداخت هزینه سفر (آنلاین یا نقدی)' + '</li>' + '<li>' + 'امکان انجام سفر رفت‌وبرگشت یا دو مقصده' + '</li>' + '<li>' + 'امکان انتخاب مدت زمان توقف در مسیر' + '</li>' + '<li>' + 'پشتیبانی ۲۴ساعته با تاکسی اینترنتی' + '</li>' + '<li>' + 'امکان ذخیره آدرس‌های منتخب در اپلیکیشن' + '</li>' + '<li>' + 'امکان انجام سفر رایگان، با معرفی اسنپ به دوستان' + '</li>'
    }
}, {
    tab: {
        icon: 'icon-credit-card',
        text: 'خدمات متنوع'
    },
    content: {
        image: -200,
        header: 'چند سرویس در یک اپلیکیشن',
        subHeader: 'کاربران با نصب اپلیکیشن اسنپ می‌توانند علاوه بر استفاده از خدمات تاکسی اینترنتی از سرویس‌های مختلف سوپراپلیکیشن اسنپ هم استفاده کنند. سرویس‌هایی مانند:',
        text: '<li>' + '<strong>اسنپ اکو:</strong> سفری مقرون‌به‌صرفه و با کیفیت' + '</li>' + '<li>' + '<strong>اسنپ‌رُز:</strong> سفر بانوان و خانواده‌ها، با هم‌راهان خانم' + '</li>' + '<li>' + '<strong>اسنپ‌باکس:</strong> حمل بسته و مرسولات با موتورسیکلت' + '</li>' + '<li>' + '<strong>اسنپ‌‌‌‌‌وانت:</strong> جابه‌جایی بارهای سنگین' + '</li>' + '<li>' + '<strong>اسنپ‌بایک:</strong> جابه‌جایی مسافران با موتورسیکلت' + '</li>' + '<li>' + '<strong>اسنپ‌فود:</strong> سفارش غذا' + '</li>' + '<li>' + '<strong>اسنپ‌مارکت:</strong> خرید از سوپرمارکت‌ها و شعبه‌های هایپراستار' + '</li>' + '<li>' + '<strong>اسنپ‌تریپ:</strong> رزرو هتل‌های داخلی و خارجی و خرید بلیت هواپیما و اتوبوس' + '</li>'

    }
}, {
    tab: {
        icon: 'icon-cloud',
        text: 'راهکارهای سازمانی'
    },
    content: {
        image: -596,
        header: 'نیاز یک سازمان هوشمند',
        subHeader: 'اسنپ راهکارهایی برای هوشمندسازی حمل‌ونقل کارکنان سازمان‌ها و شرکت‌ها دارد. خدماتی مانند:',
        text: '<strong>پنل سازمانی:</strong> با ثبت‌نام در پنل سازمانی، از طریق یک صفحه وب می‌توان از تمام سرویس‌های تاکسی اینترنتی اسنپ استفاده کرد. استفاده همزمان از همه سرویس‌ها، مدیریت بهتر سفرها، شفاف‌سازی هزینه‌های حمل‌ونقل سازمانی و گزارش‌گیری قابل اعتماد از قابلیت‌های این پنل است.' + '\n' + '<strong>کد سازمانی:</strong> در این حالت، یک کد سازمانی مخصوص برای سازمان و تمام اعضای مجموعه ایجاد می‌شود. به این ترتیب ریز گزارش‌ سفرهای کارمندان به صورت هفتگی با تاکسی اینترنتی اسنپ برای مسئول سازمان ارسال می‌شود.'
    }
}];

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = [{
  id: 0,
  img: '../../../assets/images/snapp-services/bike.svg',
  title: 'اسنپ! باکس و اسنپ!‌ بایک',
  titleIntro: 'پیک‌ موتوری و تاکسی موتوری',
  desc: 'سرویس «اسنپ!‌باکس» برای جابه‌جایی بسته و مرسولات و سرویس «اسنپ!‌بایک» یا تاکسی موتوری برای جابه‌جایی در مراکز شلوغ و پُر ترافیک بهترین راهکار است.',
  link: 'https://snapp.ir/blog/using-snappbox/',
  linkAble: true
}, {
  id: 1,
  img: '../../../assets/images/snapp-services/fintech.svg',
  title: 'اسنپ! ‌بورس',
  titleIntro: 'بورس و سرمایه‌گذاری',
  desc: 'با استفاده از این سرویس می‌توانید آنلاین در سامانه سجام ثبت‌نام کنید، احزار هویت سجام را به صورت غیرحضوری انجام دهید و اقدام به مشاهده و فروش سهام عدالت کنید.',
  link: '',
  linkAble: false
}, {
  id: 2,
  img: '../../../assets/images/snapp-services/cab.svg',
  title: 'اسنپ! ',
  titleIntro: 'درخواست خودرو',
  desc: 'اسنپ! اولین و بزرگ‌ترین تاکسی اینترنتی ایران است که برای جابه‌جایی در شهرهای بزرگ و کوچک ایران آماده خدمت‌رسانی به شماست.',
  link: '',
  linkAble: false
}, {
  id: 3,
  img: '../../../assets/images/snapp-services/charity.svg',
  title: 'نیکوکاری',
  titleIntro: 'حمایت از کادر درمان و بیماران کرونا',
  desc: 'با استفاده از سرویس نیکوکاری می‌توانید بدون واسطه، کمک‌های خود را برای «مجمع خیرین سلامت کشور» واریز کنید تا نیازهای کادر درمان و بیماران کرونا تامین شود.',
  link: '',
  linkAble: false
}, {
  id: 4,
  img: '../../../assets/images/snapp-services/club.svg',
  title: 'اسنپ! ‌کلاب',
  titleIntro: 'باشگاه مشتریان اسنپ!',
  desc: 'باشگاه مشتریان اسنپ! با ارائه امکانات ویژه از همراهی کابران وفادار خود با جوایز و تخفیف‌های هیجان‌‌انگیز قدردانی می‌کند. همین حالا برای دریافت جوایز اقدام کنید.',
  link: '',
  linkAble: false
}, {
  id: 5,
  img: '../../../assets/images/snapp-services/doctor.svg',
  title: 'اسنپ! ‌دکتر',
  titleIntro: 'مشاوره پزشکی',
  desc: 'سرویس «پزشک و مشاور» اسنپ! امکان استفاده از مشاوره آنلاین پزشکی را در تمام حوزه‌ها از قبیل روانشناسی، روانپزشکی، کرونا، بیماری‌های داخلی و غیره فراهم می‌کند.',
  link: '',
  linkAble: false
}, {
  id: 6,
  img: '../../../assets/images/snapp-services/food.svg',
  title: 'اسنپ! ‌فود',
  titleIntro: 'سفارش آنلاین غذا',
  desc: 'اسنپ!‌فود اولین و بزرگ‌ترین سامانه سفارش آنلاین غذا در ایران است و علاوه بر سفارش غذا خدمات سفارش آنلاین کیک، شیرینی و سوپرمارکت را هم برای شما فراهم می‌کند.',
  link: '',
  linkAble: false
}, {
  id: 7,
  img: '../../../assets/images/snapp-services/market.svg',
  title: 'اسنپ! ‌مارکت',
  titleIntro: 'خرید از هایپراستار و سوپرمارکت‌',
  desc: 'با اسنپ!‌مارکت دیگر دغدغه خرید انواع محصولات سوپرمارکتی را ندارید؛ امکان خرید از «هایپراستار» در برخی از شهرها و خرید آنلاین از سوپرمارکت‌های اطراف.',
  link: '',
  linkAble: false
}, {
  id: 8,
  img: '../../../assets/images/snapp-services/pay.svg',
  title: 'اسنپ! ‌پرداخت',
  titleIntro: 'خرید شارژ سیم‌کارت و بسته اینترنت، پرداخت قبض',
  desc: 'با اسنپ! به راحتی سیم‌کارت خود (ایرانسل، همراه اول، رایتل یا آذرتل) را شارژ کنید، بسته اینترنتی بخرید و یا قبض‌های خود را پرداخت کنید.',
  link: '',
  linkAble: false
}, {
  id: 9,
  img: '../../../assets/images/snapp-services/q.svg',
  title: 'اسنپ! کیو',
  titleIntro: 'بازی',
  desc: 'برای سرگرمی می‌توانید از سرویس «بازی» اسنپ! استفاده کنید و هر روز با شرکت در بازی‌های مختلف به صورت فردی یا با دوستان خود جایزه ببرید.',
  link: '',
  linkAble: false
}, {
  id: 10,
  img: '../../../assets/images/snapp-services/trip.svg',
  title: 'اسنپ! ‌تریپ',
  titleIntro: 'خرید بلیت، رزرو هتل و اقامتگاه',
  desc: 'با استفاده از اسنپ! برای سفر خود به طور کامل برنامه‌ریزی کنید؛ خرید بلیت هواپیما، قطار و اتوبوس به همراه رزرو هتل و اقامتگاه اقتصادی.',
  link: '',
  linkAble: false
}, {
  id: 11,
  img: '../../../assets/images/snapp-services/van.svg',
  title: 'اسنپ! ‌وانت',
  titleIntro: 'درخواست آنلاین وانت',
  desc: 'برای حمل‌ونقل وسایل حجیم و سنگین (تا ۵۰۰ کیلوگرم) به راحتی از سرویس «وانت» اسنپ! استفاده کنید.',
  link: '',
  linkAble: false
}];

/***/ }),

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(111)();
// imports


// module
exports.push([module.i, ".d-none {\n  display: none;\n}\n#CenterElement {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n}\n#Button {\n  background-color: #00d170;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);\n  position: relative;\n  display: -webkit-inline-box;\n  display: -webkit-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  padding: 7px 15px;\n  min-height: 30px;\n  min-width: 4rem;\n  overflow: hidden;\n  line-height: 2;\n  text-align: center;\n  font-weight: 800;\n  border: 0;\n  border-radius: 2rem;\n  vertical-align: middle;\n  white-space: nowrap;\n  cursor: pointer;\n  -ms-touch-action: manipulation;\n      touch-action: manipulation;\n  -webkit-transition: all ease-in-out 0.175s;\n  transition: all ease-in-out 0.175s;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  color: #eee;\n  text-decoration: none;\n  -webkit-transition: all 450ms ease-in-out;\n  transition: all 450ms ease-in-out;\n}\n#Button i {\n  line-height: 35px;\n  text-align: center;\n  vertical-align: middle;\n}\n#Button:hover,\n#Button:active,\n#Button:focus {\n  background-color: #03d873;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15), 0 1px 4px rgba(0, 0, 0, 0.1);\n}\n#Button i {\n  margin-left: 0;\n}\n#BrightHover {\n  -webkit-transition: all 450ms ease-in-out;\n  transition: all 450ms ease-in-out;\n}\n#BrightHover:hover {\n  opacity: 0.6;\n}\n@-webkit-keyframes fade-in {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 0.6;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes fade-in {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 0.6;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.Snapp-Features {\n  width: 100%;\n  position: relative;\n  padding: 30px 0;\n  background: #eee -webkit-radial-gradient(circle, rgba(238, 238, 238, 0.9), #cadae2);\n  background: #eee radial-gradient(circle, rgba(238, 238, 238, 0.9), #cadae2);\n}\n.Snapp-Features .F-Header {\n  font-size: 32px;\n  direction: rtl;\n  text-align: right;\n  width: 95%;\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n.Snapp-Features .Wrapper {\n  width: 100%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n.Snapp-Features .Snapp-Features-Inner {\n  height: 680px;\n  width: 71%;\n  display: -webkit-inline-box;\n  display: -webkit-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  direction: rtl;\n  margin: auto;\n}\n.Snapp-Features .Snapp-Features-Inner ul,\n.Snapp-Features .Snapp-Features-Inner li {\n  list-style: disc;\n  margin-bottom: 2px;\n}\n.Snapp-Features .Snapp-Features-Inner .Tabs {\n  width: 22.66666667%;\n  top: 50%;\n  position: relative;\n  -webkit-transform: translateY(-50%);\n      -ms-transform: translateY(-50%);\n          transform: translateY(-50%);\n}\n.Snapp-Features .Snapp-Features-Inner .Tabs .Tab {\n  cursor: pointer;\n  width: 100%;\n  text-align: center;\n  font-size: 20px;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);\n  box-shadow: 0 0 0 1px #00adbc, 0 0.65rem 1rem rgba(48, 77, 105, 0.1), 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);\n  height: 55px;\n  border: solid 1px #00ef74;\n  border-radius: 0 3px 3px 0;\n  background-color: #00d170;\n  padding: 12px 5px;\n  margin: 15px 0;\n  color: #eee;\n  font-weight: 600;\n  -webkit-transition: all 450ms ease-in-out;\n  transition: all 450ms ease-in-out;\n}\n.Snapp-Features .Snapp-Features-Inner .Tabs .Tab i {\n  width: 100%;\n  text-align: center;\n  font-size: 24px;\n}\n.Snapp-Features .Snapp-Features-Inner .Tabs .Tab:hover,\n.Snapp-Features .Snapp-Features-Inner .Tabs .active {\n  box-shadow: 0 0 0 1px #008a96, 0 10px 20px 0 rgba(48, 77, 105, 0.1), 0 6px 10px 0 rgba(0, 0, 0, 0.1);\n  background-color: #00b36e;\n}\n.Snapp-Features .Snapp-Features-Inner .Pages {\n  position: relative;\n  height: 390px;\n  width: 83.33333333%;\n  background-color: white;\n  border-radius: 3px;\n  display: -webkit-inline-box;\n  display: -webkit-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  padding: 100px 50px;\n  box-shadow: 1px 16px 22px 2px rgba(74, 94, 127, 0.114), 0px 15px 56px 0px rgba(0, 0, 0, 0.1), 0.5rem 1rem 2rem rgba(36, 72, 105, 0.15);\n}\n.Snapp-Features .Snapp-Features-Inner .Pages .Image,\n.Snapp-Features .Snapp-Features-Inner .Pages .Text {\n  -webkit-animation-name: fade-in;\n          animation-name: fade-in;\n  -webkit-animation-duration: 450ms;\n          animation-duration: 450ms;\n}\n.Snapp-Features .Snapp-Features-Inner .Pages .Image {\n  overflow: hidden;\n  width: 201px;\n  height: 198px;\n  background-image: url(../../assets/images/icons-sprite.png);\n}\n.Snapp-Features .Snapp-Features-Inner .Pages .Text {\n  max-width: -webkit-calc(75% - 20px);\n  max-width: calc(75% - 20px);\n  margin-right: 20px;\n  color: #5d5e5e;\n}\n.Snapp-Features .Snapp-Features-Inner .Pages .Text h2 {\n  font-size: 32px;\n  color: #00b36e;\n  text-shadow: 0 2px 5px #dadfe0;\n}\n.Snapp-Features .Snapp-Features-Inner .Pages .Text .Sub-Header {\n  font-size: 25px;\n  line-height: 40px;\n  margin-top: 20px;\n}\n.Snapp-Features .Snapp-Features-Inner .Pages .Text .F-Text {\n  font-size: 18px;\n  line-height: 28px;\n  margin-top: 20px;\n}\n.Snapp-Features .Snapp-Features-Inner .Pages .Dots {\n  width: 14px;\n  left: 30px;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n      -ms-transform: translateY(-50%);\n          transform: translateY(-50%);\n  text-align: center;\n}\n.Snapp-Features .Snapp-Features-Inner .Pages .Dots .Dot {\n  width: 10px;\n  height: 10px;\n  background-color: #00d170;\n  margin: 20px auto;\n  border-radius: 50%;\n  cursor: pointer;\n  -webkit-transition: all 450ms ease-in-out;\n  transition: all 450ms ease-in-out;\n}\n.Snapp-Features .Snapp-Features-Inner .Pages .Dots .Dot:hover {\n  width: 12px;\n  height: 12px;\n  background-color: #00b36e;\n}\n.Snapp-Features .Snapp-Features-Inner .Pages .Dots .D-active {\n  width: 14px;\n  height: 14px;\n  background-color: #00b36e;\n}\n", ""]);

// exports


/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(111)();
// imports


// module
exports.push([module.i, ".root {\n  background-color: #f5f5f5;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  direction: rtl;\n}\n.header-container {\n  width: 100%;\n  max-width: 1000px;\n  border-bottom: solid 2px #e9e9e9;\n  margin: 64px 0 38px 0;\n}\n.header {\n  font-size: 44px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: center;\n  color: #404040;\n  margin-bottom: 35px;\n}\n.snapp-description {\n  font-size: 24px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 2.08;\n  letter-spacing: normal;\n  text-align: right;\n  color: #404040;\n  width: 100%;\n  max-width: 1000px;\n  margin-bottom: 88px;\n}\n.snapp-services-container {\n  width: 100%;\n  max-width: 1000px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: row;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-flex-wrap: wrap;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-bottom: 70px;\n}\n@media (max-width: 767px) {\n  .snapp-description {\n    width: 90%;\n    font-size: 14px;\n    margin-bottom: 50px;\n  }\n  .snapp-services-container {\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n        -ms-flex-align: center;\n            align-items: center;\n  }\n  .header {\n    font-size: 22px !important;\n    margin-bottom: 13px !important;\n  }\n  .header-container {\n    width: 90%;\n    margin: 35px 0 30px 0;\n  }\n}\n@media (min-width: 768px) and (max-width: 1023px) {\n  .snapp-description {\n    width: 95%;\n  }\n  .header-container {\n    width: 95%;\n  }\n  .snapp-services-container {\n    max-width: 710px;\n  }\n}\n@media (max-width: 281px) {\n  .snapp-services-container {\n    width: 90%;\n  }\n}\n", ""]);

// exports


/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(111)();
// imports


// module
exports.push([module.i, ".testimonial-container {\n  width: 290px;\n  padding: 27px;\n  box-sizing: border-box;\n  height: 340px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  margin-bottom: 50px;\n  border-radius: 24px;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n  border: solid 0.5px #e6e6e6;\n  background-color: #ffffff;\n}\n.image-border {\n  width: 100%;\n  text-align: center;\n}\n.testimonial-image {\n  width: 90px;\n  height: 90px;\n  object-fit: contain;\n  margin-bottom: 16px;\n}\n.testimonial-title {\n  /* width: 241px;\n    height: 68px; */\n  font-size: 20px;\n  font-weight: 900;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: center;\n  color: #404040;\n  margin-bottom: 14px;\n}\n.title-tip {\n  /* width: 169px;\n    height: 30px; */\n  font-size: 14px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: right;\n  color: #6624bd;\n  margin-bottom: 10px;\n}\n.testimonial-description {\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: right;\n  color: #404040;\n}\n@media (max-width: 768px) {\n  .testimonial-container {\n    margin-bottom: 14px;\n  }\n}\n@media (max-width: 281px) {\n  .testimonial-title {\n    font-size: 18px;\n  }\n}\n", ""]);

// exports


/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(540);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(112)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?url=false!../../node_modules/autoprefixer-loader/index.js?browsers=last 9 versions!../../node_modules/postcss-loader/index.js!../../node_modules/less-loader/index.js!./SnappFeatures.less", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?url=false!../../node_modules/autoprefixer-loader/index.js?browsers=last 9 versions!../../node_modules/postcss-loader/index.js!../../node_modules/less-loader/index.js!./SnappFeatures.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(541);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(112)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?url=false!../../node_modules/autoprefixer-loader/index.js?browsers=last 9 versions!../../node_modules/postcss-loader/index.js!../../node_modules/less-loader/index.js!./SnappServices.less", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?url=false!../../node_modules/autoprefixer-loader/index.js?browsers=last 9 versions!../../node_modules/postcss-loader/index.js!../../node_modules/less-loader/index.js!./SnappServices.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(543);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(112)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?url=false!../../node_modules/autoprefixer-loader/index.js?browsers=last 9 versions!../../node_modules/postcss-loader/index.js!../../node_modules/less-loader/index.js!./Testimonial.less", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?url=false!../../node_modules/autoprefixer-loader/index.js?browsers=last 9 versions!../../node_modules/postcss-loader/index.js!../../node_modules/less-loader/index.js!./Testimonial.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ })

});


// WEBPACK FOOTER //
// MainPage.js